/* tslint:disable */
/* eslint-disable */
/**
 * PID Backoffice Gateway, PID External
 * BackOffice Gateway to PartnersID (PID), External.
 *
 * The version of the OpenAPI document: 12.4
 * Contact: cestmir.ruzicka@partnersbanka.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// URLSearchParams not necessarily used
// @ts-ignore

// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction,
    type EndpointOptions, // THIS IS CUSTOM
  } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AdditionalClientInfoHistoryRecordV12
 */
export interface AdditionalClientInfoHistoryRecordV12 {
    /**
     * Time of record creation. yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof AdditionalClientInfoHistoryRecordV12
     */
    'createdAt': string;
    /**
     * Full name of consultant (if \'createdByPid\' is PID UUID) otherwise null. Supplied by pid-core.
     * @type {string}
     * @memberof AdditionalClientInfoHistoryRecordV12
     */
    'createdBy'?: string;
    /**
     * Source consultant (either PID UUID or some general string)
     * @type {string}
     * @memberof AdditionalClientInfoHistoryRecordV12
     */
    'createdByPid': string;
    /**
     * Defines a source client of an event. Possible values: [\'CODE\' - (Description)] - WARNING: This list is not commitment! - Note, this list may not be complete, or values may get removed without any notification. [ \'UNKNOWN\' - (), \'NONBANK\' - (Not a BANK; Nebanka), \'BANK\' - (Partners bank company), \'BANK_EMPLOYEE\' - (Identification of PID being employee (consultant) of the BANK), \'BANK_TEST\' - (), \'GEPARD\' - (Gepard Finance), \'LOAN\' - (Loan applicant indication), \'MOB_APP\' - (Mobile application (CZE)), \'MOB_APP_PAR\' - (Mobile application (Partners), \'MOB_APP_SFS\' - (Mobile application (Simplea Financial Solutions), \'MOB_APP_SK\' - (Mobile application (SVK)), \'MOB_APP_WLB\' - (Mobile application (White Label Product)), \'OCP\' - (Shares trading; Obchod s cennymi papiry), \'ORFEUS\' - (Alternative to FIP in a PFS world), \'ORFEUS_SK\' - (Alternative to FIP in a SFS world), \'PFS\' - (Partners Financial Services (CZE)), \'PFS_CONSULTANT\' - (Identification of PID being employee (consultant) of the PFS), \'PID\' - (), \'PID_TEST\' - (), \'RENTEA\' - (a retirement company (CZE)), \'SFS\' - (Simplea Financial Services (SVK)), \'SIMPLEA\' - (an insurance company (CZE)), \'SIMPLEA_SK\' - (an insurance company (SVK)), \'VUB\' - (VUB Bank) ]
     * @type {string}
     * @memberof AdditionalClientInfoHistoryRecordV12
     */
    'sourceClient': string;
    /**
     * 
     * @type {TrustLevelV11x0}
     * @memberof AdditionalClientInfoHistoryRecordV12
     */
    'trustLevel': TrustLevelV11x0;
    /**
     * Type of verification - the source of operation like OCR + validation scan or manual consultant input. Possible values: [\'CODE\' - (Description)] - WARNING: This list is not commitment! - Note, this list may not be complete, or values may get removed without any notification. [ \'UNKNOWN\' - (), \'MACHINE\' - (), \'AML_OFFICER\' - (), \'BACKOFFICE_USER\' - (), \'BANK_ID\' - (), \'CLIENT\' - (), \'CONSULTANT_EDOKLAD\' - (), \'CONSULTANT_FACE_TO_FACE\' - (), \'CONSULTANT_REMOTE\' - (), \'SZR\' - (Abbreviation for Czech Basic Public Administration Registers - \'Sprava Zakladnich Registru\'), ]
     * @type {string}
     * @memberof AdditionalClientInfoHistoryRecordV12
     */
    'verificationType': string;
    /**
     * Full name of person or company identified by \'createdByPid\'. Resolved by pid-backoffice-gateway.
     * @type {string}
     * @memberof AdditionalClientInfoHistoryRecordV12
     */
    'fullName'?: string;
    /**
     * 
     * @type {AdditionalClientInfoV12}
     * @memberof AdditionalClientInfoHistoryRecordV12
     */
    'record': AdditionalClientInfoV12;
}


/**
 * 
 * @export
 * @interface AdditionalClientInfoHistoryRecordV12AllOf
 */
export interface AdditionalClientInfoHistoryRecordV12AllOf {
    /**
     * 
     * @type {AdditionalClientInfoV12}
     * @memberof AdditionalClientInfoHistoryRecordV12AllOf
     */
    'record': AdditionalClientInfoV12;
}
/**
 * 
 * @export
 * @interface AdditionalClientInfoHistoryResponseV12
 */
export interface AdditionalClientInfoHistoryResponseV12 {
    /**
     * 
     * @type {Array<AdditionalClientInfoHistoryRecordV12>}
     * @memberof AdditionalClientInfoHistoryResponseV12
     */
    'records': Array<AdditionalClientInfoHistoryRecordV12>;
}
/**
 * 
 * @export
 * @interface AdditionalClientInfoV12
 */
export interface AdditionalClientInfoV12 {
    /**
     * Title prefix.
     * @type {string}
     * @memberof AdditionalClientInfoV12
     */
    'titlePrefix'?: string | null;
    /**
     * Title suffix.
     * @type {string}
     * @memberof AdditionalClientInfoV12
     */
    'titleSuffix'?: string | null;
    /**
     * 
     * @type {MaritalStatusV11x0}
     * @memberof AdditionalClientInfoV12
     */
    'maritalStatus'?: MaritalStatusV11x0;
    /**
     * Způsobilost k právním úkonům.
     * @type {boolean}
     * @memberof AdditionalClientInfoV12
     */
    'legalCapacity'?: boolean | null;
    /**
     * Zletilost.
     * @type {boolean}
     * @memberof AdditionalClientInfoV12
     */
    'legalAge'?: boolean | null;
    /**
     * All user\'s nationalities, ISO 3166-1 format, subtype ALPHA-3. This means three letters in uppercase.
     * @type {Array<CountryCodeV1x1>}
     * @memberof AdditionalClientInfoV12
     */
    'nationalities'?: Array<CountryCodeV1x1> | null;
    /**
     * Fatca.
     * @type {boolean}
     * @memberof AdditionalClientInfoV12
     */
    'fatca': boolean;
    /**
     * List of country codes related to person
     * @type {Array<CountryCodeV1x1>}
     * @memberof AdditionalClientInfoV12
     */
    'taxDomiciles': Array<CountryCodeV1x1>;
    /**
     * PEP - politicky exponovana osoba.
     * @type {boolean}
     * @memberof AdditionalClientInfoV12
     */
    'pep': boolean;
    /**
     * Date of death of the client. Practically still null. Only in the case of updating data (not yet part of the standard definition) is it possible to receive a specific date.
     * @type {string}
     * @memberof AdditionalClientInfoV12
     */
    'dateOfDeath'?: string | null;
    /**
     * Identifikační číslo osoby (ičo)
     * @type {string}
     * @memberof AdditionalClientInfoV12
     */
    'companyIdentificationNumber'?: string | null;
    /**
     * NACE codes
     * @type {Array<NaceCodeV12>}
     * @memberof AdditionalClientInfoV12
     */
    'naceCodes': Array<NaceCodeV12>;
    /**
     * ESA 2010 codes
     * @type {Array<string>}
     * @memberof AdditionalClientInfoV12
     */
    'esaCodes': Array<string>;
    /**
     * Total (monthly) income
     * @type {number}
     * @memberof AdditionalClientInfoV12
     */
    'totalIncome'?: number | null;
    /**
     * Testovací klient
     * @type {boolean}
     * @memberof AdditionalClientInfoV12
     */
    'testClient': boolean;
    /**
     * Testovací klient - pocatek
     * @type {string}
     * @memberof AdditionalClientInfoV12
     */
    'testClientFrom'?: string | null;
    /**
     * 
     * @type {AdditionalClientInfoV12IncomeSources}
     * @memberof AdditionalClientInfoV12
     */
    'incomeSources': AdditionalClientInfoV12IncomeSources;
}


/**
 * Sources of income.
 * @export
 * @interface AdditionalClientInfoV12IncomeSources
 */
export interface AdditionalClientInfoV12IncomeSources {
    /**
     * 
     * @type {Array<IrregularIncomeEsaCodeV5x0>}
     * @memberof AdditionalClientInfoV12IncomeSources
     */
    'irregularIncomeEsa': Array<IrregularIncomeEsaCodeV5x0>;
    /**
     * Monthly irregular income sum.
     * @type {number}
     * @memberof AdditionalClientInfoV12IncomeSources
     */
    'irregularIncomeSum': number;
    /**
     * 
     * @type {Array<RegularIncomeEsaCodeV5x0>}
     * @memberof AdditionalClientInfoV12IncomeSources
     */
    'regularIncomeEsa': Array<RegularIncomeEsaCodeV5x0>;
    /**
     * Monthly regular income sum.
     * @type {number}
     * @memberof AdditionalClientInfoV12IncomeSources
     */
    'regularIncomeSum': number;
}
/**
 * 
 * @export
 * @interface AddressActionsV12
 */
export interface AddressActionsV12 {
    /**
     * 
     * @type {CheckAddressV12}
     * @memberof AddressActionsV12
     */
    'update': CheckAddressV12;
    /**
     * 
     * @type {CheckAddressV12}
     * @memberof AddressActionsV12
     */
    'delete': CheckAddressV12;
}
/**
 * 
 * @export
 * @interface AddressHistoryItemV12
 */
export interface AddressHistoryItemV12 {
    /**
     * 
     * @type {AddressV12}
     * @memberof AddressHistoryItemV12
     */
    'address': AddressV12;
    /**
     * 
     * @type {AddressTypeV11x0}
     * @memberof AddressHistoryItemV12
     */
    'type': AddressTypeV11x0;
}


/**
 * 
 * @export
 * @interface AddressHistoryRecordV12
 */
export interface AddressHistoryRecordV12 {
    /**
     * Time of record creation. yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof AddressHistoryRecordV12
     */
    'createdAt': string;
    /**
     * Full name of consultant (if \'createdByPid\' is PID UUID) otherwise null. Supplied by pid-core.
     * @type {string}
     * @memberof AddressHistoryRecordV12
     */
    'createdBy'?: string;
    /**
     * Source consultant (either PID UUID or some general string)
     * @type {string}
     * @memberof AddressHistoryRecordV12
     */
    'createdByPid': string;
    /**
     * Defines a source client of an event. Possible values: [\'CODE\' - (Description)] - WARNING: This list is not commitment! - Note, this list may not be complete, or values may get removed without any notification. [ \'UNKNOWN\' - (), \'NONBANK\' - (Not a BANK; Nebanka), \'BANK\' - (Partners bank company), \'BANK_EMPLOYEE\' - (Identification of PID being employee (consultant) of the BANK), \'BANK_TEST\' - (), \'GEPARD\' - (Gepard Finance), \'LOAN\' - (Loan applicant indication), \'MOB_APP\' - (Mobile application (CZE)), \'MOB_APP_PAR\' - (Mobile application (Partners), \'MOB_APP_SFS\' - (Mobile application (Simplea Financial Solutions), \'MOB_APP_SK\' - (Mobile application (SVK)), \'MOB_APP_WLB\' - (Mobile application (White Label Product)), \'OCP\' - (Shares trading; Obchod s cennymi papiry), \'ORFEUS\' - (Alternative to FIP in a PFS world), \'ORFEUS_SK\' - (Alternative to FIP in a SFS world), \'PFS\' - (Partners Financial Services (CZE)), \'PFS_CONSULTANT\' - (Identification of PID being employee (consultant) of the PFS), \'PID\' - (), \'PID_TEST\' - (), \'RENTEA\' - (a retirement company (CZE)), \'SFS\' - (Simplea Financial Services (SVK)), \'SIMPLEA\' - (an insurance company (CZE)), \'SIMPLEA_SK\' - (an insurance company (SVK)), \'VUB\' - (VUB Bank) ]
     * @type {string}
     * @memberof AddressHistoryRecordV12
     */
    'sourceClient': string;
    /**
     * 
     * @type {TrustLevelV11x0}
     * @memberof AddressHistoryRecordV12
     */
    'trustLevel': TrustLevelV11x0;
    /**
     * Type of verification - the source of operation like OCR + validation scan or manual consultant input. Possible values: [\'CODE\' - (Description)] - WARNING: This list is not commitment! - Note, this list may not be complete, or values may get removed without any notification. [ \'UNKNOWN\' - (), \'MACHINE\' - (), \'AML_OFFICER\' - (), \'BACKOFFICE_USER\' - (), \'BANK_ID\' - (), \'CLIENT\' - (), \'CONSULTANT_EDOKLAD\' - (), \'CONSULTANT_FACE_TO_FACE\' - (), \'CONSULTANT_REMOTE\' - (), \'SZR\' - (Abbreviation for Czech Basic Public Administration Registers - \'Sprava Zakladnich Registru\'), ]
     * @type {string}
     * @memberof AddressHistoryRecordV12
     */
    'verificationType': string;
    /**
     * Full name of person or company identified by \'createdByPid\'. Resolved by pid-backoffice-gateway.
     * @type {string}
     * @memberof AddressHistoryRecordV12
     */
    'fullName'?: string;
    /**
     * 
     * @type {AddressHistoryItemV12}
     * @memberof AddressHistoryRecordV12
     */
    'record': AddressHistoryItemV12;
}


/**
 * 
 * @export
 * @interface AddressHistoryRecordV12AllOf
 */
export interface AddressHistoryRecordV12AllOf {
    /**
     * 
     * @type {AddressHistoryItemV12}
     * @memberof AddressHistoryRecordV12AllOf
     */
    'record': AddressHistoryItemV12;
}
/**
 * 
 * @export
 * @interface AddressHistoryResponseV12
 */
export interface AddressHistoryResponseV12 {
    /**
     * 
     * @type {Array<AddressHistoryRecordV12>}
     * @memberof AddressHistoryResponseV12
     */
    'records': Array<AddressHistoryRecordV12>;
}
/**
 * Address type - permanent residence or contact. Permanent could be changed only by Id Card if already exists one by another ID Card.
 * @export
 * @enum {string}
 */

export const AddressTypeV11x0 = {
    PERMANENT_RESIDENCE: 'PERMANENT_RESIDENCE',
    CONTACT_RESIDENCE: 'CONTACT_RESIDENCE',
    UNKNOWN: 'UNKNOWN'
} as const;

export type AddressTypeV11x0 = typeof AddressTypeV11x0[keyof typeof AddressTypeV11x0];


/**
 * 
 * @export
 * @interface AddressV12
 */
export interface AddressV12 {
    /**
     * Obec
     * @type {string}
     * @memberof AddressV12
     */
    'city': string;
    /**
     * CastObce
     * @type {string}
     * @memberof AddressV12
     */
    'cityPart'?: string | null;
    /**
     * Ulice
     * @type {string}
     * @memberof AddressV12
     */
    'street'?: string | null;
    /**
     * cislo popisne (domovni)
     * @type {string}
     * @memberof AddressV12
     */
    'houseNumber'?: string | null;
    /**
     * cislo orientacni
     * @type {string}
     * @memberof AddressV12
     */
    'streetNumber'?: string | null;
    /**
     * cislo evidencni
     * @type {string}
     * @memberof AddressV12
     */
    'evidenceNumber'?: string | null;
    /**
     * znak orientacni
     * @type {string}
     * @memberof AddressV12
     */
    'buildingApartment'?: string | null;
    /**
     * Pcs
     * @type {string}
     * @memberof AddressV12
     */
    'zipcode': string;
    /**
     * 
     * @type {CountryCodeV1x1}
     * @memberof AddressV12
     */
    'country': CountryCodeV1x1;
    /**
     * Ruian refference Id
     * @type {string}
     * @memberof AddressV12
     */
    'ruianReference'?: string | null;
}


/**
 * 
 * @export
 * @interface AdvisorDetailAddressV12
 */
export interface AdvisorDetailAddressV12 {
    /**
     * 
     * @type {string}
     * @memberof AdvisorDetailAddressV12
     */
    'street'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdvisorDetailAddressV12
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdvisorDetailAddressV12
     */
    'zip'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdvisorDetailAddressV12
     */
    'position'?: string;
}
/**
 * 
 * @export
 * @interface AdvisorDetailIdAndNameV12
 */
export interface AdvisorDetailIdAndNameV12 {
    /**
     * 
     * @type {number}
     * @memberof AdvisorDetailIdAndNameV12
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdvisorDetailIdAndNameV12
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface AdvisorDetailNameV12
 */
export interface AdvisorDetailNameV12 {
    /**
     * 
     * @type {string}
     * @memberof AdvisorDetailNameV12
     */
    'first'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdvisorDetailNameV12
     */
    'last'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdvisorDetailNameV12
     */
    'full'?: string;
}
/**
 * 
 * @export
 * @interface AdvisorDetailPhotoV12
 */
export interface AdvisorDetailPhotoV12 {
    /**
     * 
     * @type {string}
     * @memberof AdvisorDetailPhotoV12
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof AdvisorDetailPhotoV12
     */
    'data': string;
}
/**
 * 
 * @export
 * @interface AdvisorDetailTitleV12
 */
export interface AdvisorDetailTitleV12 {
    /**
     * 
     * @type {string}
     * @memberof AdvisorDetailTitleV12
     */
    'before'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdvisorDetailTitleV12
     */
    'after'?: string;
}
/**
 * Status of AIS processing. Can take the values: (\'UNRATED, \'NOT_FOR_AIS_IDENTIFICATION, \'AIS_PROCESSING\', \'AIS_PARTIALLY_IDENTIFIED\', \'AIS_IDENTIFIED\', \'AIS_PARTIALLY_UPDATED\', \'AIS_UPDATED\', \'AIS_UNSUBSCRIBED\', \'AIS_NOT_IDENTIFIED\') and others 
 * @export
 * @enum {string}
 */

export const AisStatusEnumV12 = {
    UNRATED: 'UNRATED',
    NOT_FOR_AIS_IDENTIFICATION: 'NOT_FOR_AIS_IDENTIFICATION',
    AIS_PROCESSING: 'AIS_PROCESSING',
    AIS_PARTIALLY_IDENTIFIED: 'AIS_PARTIALLY_IDENTIFIED',
    AIS_IDENTIFIED: 'AIS_IDENTIFIED',
    AIS_PARTIALLY_UPDATED: 'AIS_PARTIALLY_UPDATED',
    AIS_UPDATED: 'AIS_UPDATED',
    AIS_UNSUBSCRIBED: 'AIS_UNSUBSCRIBED',
    AIS_NOT_IDENTIFIED: 'AIS_NOT_IDENTIFIED',
    UNKNOWN: 'UNKNOWN'
} as const;

export type AisStatusEnumV12 = typeof AisStatusEnumV12[keyof typeof AisStatusEnumV12];


/**
 * 
 * @export
 * @interface AisVerificationV12
 */
export interface AisVerificationV12 {
    /**
     * 
     * @type {CheckAisV12}
     * @memberof AisVerificationV12
     */
    'identify': CheckAisV12;
    /**
     * 
     * @type {CheckAisV12}
     * @memberof AisVerificationV12
     */
    'update': CheckAisV12;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const AlertAreaV12 = {
    CLIENT: 'CLIENT',
    APPLICATIONS: 'APPLICATIONS',
    BANKID: 'BANKID'
} as const;

export type AlertAreaV12 = typeof AlertAreaV12[keyof typeof AlertAreaV12];


/**
 * 
 * @export
 * @enum {string}
 */

export const AlertKeyV12 = {
    DATA_EMAIL_MISSING: 'CLIENT_DATA_EMAIL_MISSING',
    DATA_PHONE_MISSING: 'CLIENT_DATA_PHONE_MISSING',
    DATA_PERMANENT_ADDRESS_MISSING: 'CLIENT_DATA_PERMANENT_ADDRESS_MISSING',
    APPLICATIONS_BLOCKED: 'CLIENT_APPLICATIONS_BLOCKED',
    NEW_ACTIVATIONS_BLOCKED: 'CLIENT_NEW_ACTIVATIONS_BLOCKED',
    ACTIVATIONS_WAITING_FOR_MANUAL_IDENTIFICATION: 'CLIENT_ACTIVATIONS_WAITING_FOR_MANUAL_IDENTIFICATION',
    BANK_IDENTITY_BLOCKED: 'CLIENT_BANK_IDENTITY_BLOCKED',
    PID_BLOCKED: 'CLIENT_PID_BLOCKED'
} as const;

export type AlertKeyV12 = typeof AlertKeyV12[keyof typeof AlertKeyV12];


/**
 * 
 * @export
 * @enum {string}
 */

export const AlertLevelV12 = {
    WARN: 'WARN',
    INFO: 'INFO'
} as const;

export type AlertLevelV12 = typeof AlertLevelV12[keyof typeof AlertLevelV12];


/**
 * 
 * @export
 * @enum {string}
 */

export const AmlRiskProfileV12 = {
    UNKNOWN: 'UNKNOWN',
    LOW: 'LOW',
    MEDIUM: 'MEDIUM',
    HIGH: 'HIGH',
    UNACCEPTABLE: 'UNACCEPTABLE'
} as const;

export type AmlRiskProfileV12 = typeof AmlRiskProfileV12[keyof typeof AmlRiskProfileV12];


/**
 * 
 * @export
 * @interface AmlRiskStatusV12
 */
export interface AmlRiskStatusV12 {
    /**
     * 
     * @type {string}
     * @memberof AmlRiskStatusV12
     */
    'company'?: string | null;
    /**
     * 
     * @type {AmlRiskProfileV12}
     * @memberof AmlRiskStatusV12
     */
    'riskProfileValue'?: AmlRiskProfileV12;
}


/**
 * 
 * @export
 * @interface AmlV12
 */
export interface AmlV12 {
    /**
     * 
     * @type {boolean}
     * @memberof AmlV12
     */
    'abnormalBehavior'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AmlV12
     */
    'blacklist'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AmlV12
     */
    'clientReported'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AmlV12
     */
    'comment'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AmlV12
     */
    'countryEmbargoDeal'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AmlV12
     */
    'countryEmbargoNationality'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AmlV12
     */
    'countryEmbargoResidency'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AmlV12
     */
    'countryEmbargoTaxResidency'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AmlV12
     */
    'countryRiskDeal'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AmlV12
     */
    'countryRiskNationality'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AmlV12
     */
    'countryRiskResidency'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AmlV12
     */
    'countryRiskTaxResidency'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AmlV12
     */
    'countryRiskTransactionSum7d'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AmlV12
     */
    'customFlagPfs'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AmlV12
     */
    'customFlagPis'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AmlV12
     */
    'customFlagRentea'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AmlV12
     */
    'customFlagSimplea'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AmlV12
     */
    'declaredIncomeReached'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AmlV12
     */
    'documents'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AmlV12
     */
    'largeTransactionExPost'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AmlV12
     */
    'largeTransactionOnline'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AmlV12
     */
    'largeTransactionSum30d'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AmlV12
     */
    'largeTransactionSum7d'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AmlV12
     */
    'largeTransactionSumFloat'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AmlV12
     */
    'pep'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AmlV12
     */
    'pepFunction'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AmlV12
     */
    'pepRelation'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AmlV12
     */
    'regulatorQuestionsClient'?: boolean | null;
    /**
     * 
     * @type {Array<AmlRiskStatusV12>}
     * @memberof AmlV12
     */
    'riskStatusList'?: Array<AmlRiskStatusV12> | null;
    /**
     * 
     * @type {boolean}
     * @memberof AmlV12
     */
    'riskyOccupation'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AmlV12
     */
    'sanctionedEntity'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AmlV12
     */
    'sanctionedEntityDeal'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AmlV12
     */
    'serviceAnalysisRequired'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AmlV12
     */
    'sleeperAccount'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AmlV12
     */
    'tooManyTransactions'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AmlV12
     */
    'transitAccount'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AmlV12
     */
    'unacceptableResidence'?: boolean | null;
}
/**
 * 
 * @export
 * @interface BankAccountV12
 */
export interface BankAccountV12 {
    /**
     * prefix
     * @type {string}
     * @memberof BankAccountV12
     */
    'accountPrefix'?: string | null;
    /**
     * Cislo uctu
     * @type {string}
     * @memberof BankAccountV12
     */
    'accountNumber'?: string | null;
    /**
     * kod banky
     * @type {string}
     * @memberof BankAccountV12
     */
    'bankCode'?: string | null;
    /**
     * 
     * @type {CountryCodeV1x1}
     * @memberof BankAccountV12
     */
    'country': CountryCodeV1x1;
    /**
     * iban
     * @type {string}
     * @memberof BankAccountV12
     */
    'iban'?: string | null;
}


/**
 * 
 * @export
 * @interface BankIdentityInNiaV5x0
 */
export interface BankIdentityInNiaV5x0 {
    /**
     * 
     * @type {boolean}
     * @memberof BankIdentityInNiaV5x0
     */
    'fetchResult': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BankIdentityInNiaV5x0
     */
    'blocked'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BankIdentityInNiaV5x0
     */
    'hasNiaIdentity'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BankIdentityInNiaV5x0
     */
    'hasBankIdentityBlockedInMobApp'?: boolean;
}
/**
 * 
 * @export
 * @interface BasicPidV12
 */
export interface BasicPidV12 {
    /**
     * Unique identifier of the client
     * @type {string}
     * @memberof BasicPidV12
     */
    'pidUuid': string;
    /**
     * 
     * @type {string}
     * @memberof BasicPidV12
     */
    'givenName'?: string;
    /**
     * 
     * @type {string}
     * @memberof BasicPidV12
     */
    'middleName'?: string;
    /**
     * 
     * @type {string}
     * @memberof BasicPidV12
     */
    'familyName'?: string;
}
/**
 * 
 * @export
 * @interface CheckAddressV12
 */
export interface CheckAddressV12 {
    /**
     * 
     * @type {Array<AddressTypeV11x0>}
     * @memberof CheckAddressV12
     */
    'allowedAddressTypes': Array<AddressTypeV11x0>;
}
/**
 * 
 * @export
 * @interface CheckAisV12
 */
export interface CheckAisV12 {
    /**
     * 
     * @type {Array<CompanyIdV5x0>}
     * @memberof CheckAisV12
     */
    'allowedClientships': Array<CompanyIdV5x0>;
}
/**
 * 
 * @export
 * @interface CheckIdCardActionsV12
 */
export interface CheckIdCardActionsV12 {
    /**
     * 
     * @type {CheckIdCardsV12}
     * @memberof CheckIdCardActionsV12
     */
    'update': CheckIdCardsV12;
    /**
     * 
     * @type {CheckIdCardsV12}
     * @memberof CheckIdCardActionsV12
     */
    'delete': CheckIdCardsV12;
}
/**
 * 
 * @export
 * @interface CheckIdCardV12
 */
export interface CheckIdCardV12 {
    /**
     * 
     * @type {CountryCodeV1x1}
     * @memberof CheckIdCardV12
     */
    'country': CountryCodeV1x1;
    /**
     * 
     * @type {IdCardTypeV11x0}
     * @memberof CheckIdCardV12
     */
    'type': IdCardTypeV11x0;
}


/**
 * 
 * @export
 * @interface CheckIdCardsV12
 */
export interface CheckIdCardsV12 {
    /**
     * 
     * @type {Array<CheckIdCardV12>}
     * @memberof CheckIdCardsV12
     */
    'allowed': Array<CheckIdCardV12>;
}
/**
 * 
 * @export
 * @interface CheckNationalIdentifierV12
 */
export interface CheckNationalIdentifierV12 {
    /**
     * 
     * @type {Array<string>}
     * @memberof CheckNationalIdentifierV12
     */
    'allowedNationalIdentifierTypes'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CheckNationalIdentifierWrapperV12
 */
export interface CheckNationalIdentifierWrapperV12 {
    /**
     * 
     * @type {CheckNationalIdentifierV12}
     * @memberof CheckNationalIdentifierWrapperV12
     */
    'update'?: CheckNationalIdentifierV12;
    /**
     * 
     * @type {CheckNationalIdentifierV12}
     * @memberof CheckNationalIdentifierWrapperV12
     */
    'delete'?: CheckNationalIdentifierV12;
}
/**
 * 
 * @export
 * @interface ClientActivationsWaitingForManualIdentificationAffectedApplicationActivationV12
 */
export interface ClientActivationsWaitingForManualIdentificationAffectedApplicationActivationV12 {
    /**
     * 
     * @type {string}
     * @memberof ClientActivationsWaitingForManualIdentificationAffectedApplicationActivationV12
     */
    'processUuid': string;
    /**
     * 
     * @type {ProcessTypeV12}
     * @memberof ClientActivationsWaitingForManualIdentificationAffectedApplicationActivationV12
     */
    'processType': ProcessTypeV12;
    /**
     * 
     * @type {string}
     * @memberof ClientActivationsWaitingForManualIdentificationAffectedApplicationActivationV12
     */
    'createdAt': string;
}


/**
 * 
 * @export
 * @interface ClientActivationsWaitingForManualIdentificationV12
 */
export interface ClientActivationsWaitingForManualIdentificationV12 {
    /**
     * 
     * @type {Array<ClientActivationsWaitingForManualIdentificationAffectedApplicationActivationV12>}
     * @memberof ClientActivationsWaitingForManualIdentificationV12
     */
    'affectedApplicationActivations': Array<ClientActivationsWaitingForManualIdentificationAffectedApplicationActivationV12>;
    /**
     * 
     * @type {AlertKeyV12}
     * @memberof ClientActivationsWaitingForManualIdentificationV12
     */
    'key': AlertKeyV12;
    /**
     * 
     * @type {AlertLevelV12}
     * @memberof ClientActivationsWaitingForManualIdentificationV12
     */
    'level': AlertLevelV12;
}


/**
 * 
 * @export
 * @interface ClientApplicationsBlockedV12
 */
export interface ClientApplicationsBlockedV12 {
    /**
     * 
     * @type {AlertKeyV12}
     * @memberof ClientApplicationsBlockedV12
     */
    'key': AlertKeyV12;
    /**
     * 
     * @type {AlertLevelV12}
     * @memberof ClientApplicationsBlockedV12
     */
    'level': AlertLevelV12;
}


/**
 * 
 * @export
 * @interface ClientBankIdentityBlockedV12
 */
export interface ClientBankIdentityBlockedV12 {
    /**
     * 
     * @type {AlertKeyV12}
     * @memberof ClientBankIdentityBlockedV12
     */
    'key': AlertKeyV12;
    /**
     * 
     * @type {AlertLevelV12}
     * @memberof ClientBankIdentityBlockedV12
     */
    'level': AlertLevelV12;
}


/**
 * 
 * @export
 * @interface ClientDataEmailMissingV12
 */
export interface ClientDataEmailMissingV12 {
    /**
     * 
     * @type {AlertKeyV12}
     * @memberof ClientDataEmailMissingV12
     */
    'key': AlertKeyV12;
    /**
     * 
     * @type {AlertLevelV12}
     * @memberof ClientDataEmailMissingV12
     */
    'level': AlertLevelV12;
}


/**
 * 
 * @export
 * @interface ClientDataPermanentAddressMissingV12
 */
export interface ClientDataPermanentAddressMissingV12 {
    /**
     * 
     * @type {AlertKeyV12}
     * @memberof ClientDataPermanentAddressMissingV12
     */
    'key': AlertKeyV12;
    /**
     * 
     * @type {AlertLevelV12}
     * @memberof ClientDataPermanentAddressMissingV12
     */
    'level': AlertLevelV12;
}


/**
 * 
 * @export
 * @interface ClientDataPhoneMissingV12
 */
export interface ClientDataPhoneMissingV12 {
    /**
     * 
     * @type {AlertKeyV12}
     * @memberof ClientDataPhoneMissingV12
     */
    'key': AlertKeyV12;
    /**
     * 
     * @type {AlertLevelV12}
     * @memberof ClientDataPhoneMissingV12
     */
    'level': AlertLevelV12;
}


/**
 * 
 * @export
 * @interface ClientDetailV12
 */
export interface ClientDetailV12 {
    /**
     * 
     * @type {string}
     * @memberof ClientDetailV12
     */
    'pidUuid': string;
    /**
     * 
     * @type {string}
     * @memberof ClientDetailV12
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof ClientDetailV12
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof ClientDetailV12
     */
    'lastViewedAt': string;
}
/**
 * 
 * @export
 * @interface ClientInfoHistoryRecordV12
 */
export interface ClientInfoHistoryRecordV12 {
    /**
     * Time of record creation. yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof ClientInfoHistoryRecordV12
     */
    'createdAt': string;
    /**
     * Full name of consultant (if \'createdByPid\' is PID UUID) otherwise null. Supplied by pid-core.
     * @type {string}
     * @memberof ClientInfoHistoryRecordV12
     */
    'createdBy'?: string;
    /**
     * Source consultant (either PID UUID or some general string)
     * @type {string}
     * @memberof ClientInfoHistoryRecordV12
     */
    'createdByPid': string;
    /**
     * Defines a source client of an event. Possible values: [\'CODE\' - (Description)] - WARNING: This list is not commitment! - Note, this list may not be complete, or values may get removed without any notification. [ \'UNKNOWN\' - (), \'NONBANK\' - (Not a BANK; Nebanka), \'BANK\' - (Partners bank company), \'BANK_EMPLOYEE\' - (Identification of PID being employee (consultant) of the BANK), \'BANK_TEST\' - (), \'GEPARD\' - (Gepard Finance), \'LOAN\' - (Loan applicant indication), \'MOB_APP\' - (Mobile application (CZE)), \'MOB_APP_PAR\' - (Mobile application (Partners), \'MOB_APP_SFS\' - (Mobile application (Simplea Financial Solutions), \'MOB_APP_SK\' - (Mobile application (SVK)), \'MOB_APP_WLB\' - (Mobile application (White Label Product)), \'OCP\' - (Shares trading; Obchod s cennymi papiry), \'ORFEUS\' - (Alternative to FIP in a PFS world), \'ORFEUS_SK\' - (Alternative to FIP in a SFS world), \'PFS\' - (Partners Financial Services (CZE)), \'PFS_CONSULTANT\' - (Identification of PID being employee (consultant) of the PFS), \'PID\' - (), \'PID_TEST\' - (), \'RENTEA\' - (a retirement company (CZE)), \'SFS\' - (Simplea Financial Services (SVK)), \'SIMPLEA\' - (an insurance company (CZE)), \'SIMPLEA_SK\' - (an insurance company (SVK)), \'VUB\' - (VUB Bank) ]
     * @type {string}
     * @memberof ClientInfoHistoryRecordV12
     */
    'sourceClient': string;
    /**
     * 
     * @type {TrustLevelV11x0}
     * @memberof ClientInfoHistoryRecordV12
     */
    'trustLevel': TrustLevelV11x0;
    /**
     * Type of verification - the source of operation like OCR + validation scan or manual consultant input. Possible values: [\'CODE\' - (Description)] - WARNING: This list is not commitment! - Note, this list may not be complete, or values may get removed without any notification. [ \'UNKNOWN\' - (), \'MACHINE\' - (), \'AML_OFFICER\' - (), \'BACKOFFICE_USER\' - (), \'BANK_ID\' - (), \'CLIENT\' - (), \'CONSULTANT_EDOKLAD\' - (), \'CONSULTANT_FACE_TO_FACE\' - (), \'CONSULTANT_REMOTE\' - (), \'SZR\' - (Abbreviation for Czech Basic Public Administration Registers - \'Sprava Zakladnich Registru\'), ]
     * @type {string}
     * @memberof ClientInfoHistoryRecordV12
     */
    'verificationType': string;
    /**
     * Full name of person or company identified by \'createdByPid\'. Resolved by pid-backoffice-gateway.
     * @type {string}
     * @memberof ClientInfoHistoryRecordV12
     */
    'fullName'?: string;
    /**
     * 
     * @type {ClientInfoV12}
     * @memberof ClientInfoHistoryRecordV12
     */
    'record': ClientInfoV12;
}


/**
 * 
 * @export
 * @interface ClientInfoHistoryRecordV12AllOf
 */
export interface ClientInfoHistoryRecordV12AllOf {
    /**
     * 
     * @type {ClientInfoV12}
     * @memberof ClientInfoHistoryRecordV12AllOf
     */
    'record': ClientInfoV12;
}
/**
 * 
 * @export
 * @interface ClientInfoHistoryResponseV12
 */
export interface ClientInfoHistoryResponseV12 {
    /**
     * 
     * @type {Array<ClientInfoHistoryRecordV12>}
     * @memberof ClientInfoHistoryResponseV12
     */
    'records': Array<ClientInfoHistoryRecordV12>;
}
/**
 * A class represents basic client info. Everything is based on idCard - ID card must be present in upsert operation.
 * @export
 * @interface ClientInfoV12
 */
export interface ClientInfoV12 {
    /**
     * Given name(s) or first name(s) of the End-User. Note that in some cultures, people can have multiple given names; all can be present, with the names being separated by space characters. 
     * @type {string}
     * @memberof ClientInfoV12
     */
    'givenName': string;
    /**
     * Middle name(s) of the End-User. Note that in some cultures, people can have multiple middle names; all can be present, with the names being separated by space characters. Also note that in some cultures, middle names are not used. 
     * @type {string}
     * @memberof ClientInfoV12
     */
    'middleName'?: string | null;
    /**
     * \"Surname(s) or last name(s) of the End-User. Note that in some cultures, people can have multiple family names or no family name; all can be present, with the names being separated by space characters. 
     * @type {string}
     * @memberof ClientInfoV12
     */
    'familyName': string;
    /**
     * End-User\'s birthday, represented as an ISO 8601:2004 [ISO8601‑2004] YYYY-MM-DD format. The year MAY be 0000, indicating that it is omitted. To represent only the year, YYYY format is allowed. Note that depending on the underlying platform\'s date related function, providing just year can result in valying month and day, so the implementers need to take this factor into account to correctly process the dates. 
     * @type {string}
     * @memberof ClientInfoV12
     */
    'birthday': string;
    /**
     * 
     * @type {GenderV11x0}
     * @memberof ClientInfoV12
     */
    'gender': GenderV11x0;
    /**
     * User\'s birth place city.
     * @type {string}
     * @memberof ClientInfoV12
     */
    'birthPlaceCity': string;
    /**
     * 
     * @type {CountryCodeV1x1}
     * @memberof ClientInfoV12
     */
    'birthPlaceCountry'?: CountryCodeV1x1;
    /**
     * 
     * @type {CountryCodeV1x1}
     * @memberof ClientInfoV12
     */
    'primaryNationality': CountryCodeV1x1;
}


/**
 * 
 * @export
 * @interface ClientNewActivationsBlockedV12
 */
export interface ClientNewActivationsBlockedV12 {
    /**
     * 
     * @type {Array<NationalNumberV11x0>}
     * @memberof ClientNewActivationsBlockedV12
     */
    'notBlockedNationalNumbers'?: Array<NationalNumberV11x0>;
    /**
     * 
     * @type {AlertKeyV12}
     * @memberof ClientNewActivationsBlockedV12
     */
    'key': AlertKeyV12;
    /**
     * 
     * @type {AlertLevelV12}
     * @memberof ClientNewActivationsBlockedV12
     */
    'level': AlertLevelV12;
}


/**
 * 
 * @export
 * @interface ClientPidBlockedV12
 */
export interface ClientPidBlockedV12 {
    /**
     * 
     * @type {AlertKeyV12}
     * @memberof ClientPidBlockedV12
     */
    'key': AlertKeyV12;
    /**
     * 
     * @type {AlertLevelV12}
     * @memberof ClientPidBlockedV12
     */
    'level': AlertLevelV12;
}


/**
 * A name of field to sort by.
 * @export
 * @enum {string}
 */

export const ClientSearchSortFieldV12 = {
    FIRST_NAME: 'FIRST_NAME',
    LAST_NAME: 'LAST_NAME'
} as const;

export type ClientSearchSortFieldV12 = typeof ClientSearchSortFieldV12[keyof typeof ClientSearchSortFieldV12];


/**
 * 
 * @export
 * @interface ClientSearchSortV12
 */
export interface ClientSearchSortV12 {
    /**
     * 
     * @type {ClientSearchSortFieldV12}
     * @memberof ClientSearchSortV12
     */
    'name': ClientSearchSortFieldV12;
    /**
     * 
     * @type {SortOrderTypeV1x0}
     * @memberof ClientSearchSortV12
     */
    'order': SortOrderTypeV1x0;
}


/**
 * 
 * @export
 * @interface ClientV12
 */
export interface ClientV12 {
    /**
     * Unique identifier of the client
     * @type {string}
     * @memberof ClientV12
     */
    'pidUuid': string;
    /**
     * 
     * @type {string}
     * @memberof ClientV12
     */
    'givenName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientV12
     */
    'familyName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientV12
     */
    'birthday'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientV12
     */
    'birthNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientV12
     */
    'idCardNumber'?: string | null;
    /**
     * 
     * @type {PhoneV1x1}
     * @memberof ClientV12
     */
    'phone'?: PhoneV1x1;
    /**
     * 
     * @type {EmailV11x0}
     * @memberof ClientV12
     */
    'email'?: EmailV11x0;
    /**
     * 
     * @type {AddressV12}
     * @memberof ClientV12
     */
    'permanentAddress'?: AddressV12;
}
/**
 * Narrow down what will be returned. Empty body means return everything. 
 * @export
 * @interface CollectAlertsRequestV12
 */
export interface CollectAlertsRequestV12 {
    /**
     * Empty list means return everything. 
     * @type {Array<AlertAreaV12>}
     * @memberof CollectAlertsRequestV12
     */
    'areas'?: Array<AlertAreaV12>;
    /**
     * Empty list means return everything. 
     * @type {Array<AlertLevelV12>}
     * @memberof CollectAlertsRequestV12
     */
    'levels'?: Array<AlertLevelV12>;
}
/**
 * 
 * @export
 * @interface CollectAlertsResponseAlertBaseV12
 */
export interface CollectAlertsResponseAlertBaseV12 {
    /**
     * 
     * @type {AlertKeyV12}
     * @memberof CollectAlertsResponseAlertBaseV12
     */
    'key': AlertKeyV12;
    /**
     * 
     * @type {AlertLevelV12}
     * @memberof CollectAlertsResponseAlertBaseV12
     */
    'level': AlertLevelV12;
}


/**
 * @type CollectAlertsResponseAlertV12
 * @export
 */
export type CollectAlertsResponseAlertV12 = { key: 'CLIENT_ACTIVATIONS_WAITING_FOR_MANUAL_IDENTIFICATION' } & ClientActivationsWaitingForManualIdentificationV12 | { key: 'CLIENT_APPLICATIONS_BLOCKED' } & ClientApplicationsBlockedV12 | { key: 'CLIENT_BANK_IDENTITY_BLOCKED' } & ClientBankIdentityBlockedV12 | { key: 'CLIENT_DATA_EMAIL_MISSING' } & ClientDataEmailMissingV12 | { key: 'CLIENT_DATA_PERMANENT_ADDRESS_MISSING' } & ClientDataPermanentAddressMissingV12 | { key: 'CLIENT_DATA_PHONE_MISSING' } & ClientDataPhoneMissingV12 | { key: 'CLIENT_NEW_ACTIVATIONS_BLOCKED' } & ClientNewActivationsBlockedV12 | { key: 'CLIENT_PID_BLOCKED' } & ClientPidBlockedV12;

/**
 * 
 * @export
 * @interface CollectAlertsResponseAreaV12
 */
export interface CollectAlertsResponseAreaV12 {
    /**
     * 
     * @type {AlertAreaV12}
     * @memberof CollectAlertsResponseAreaV12
     */
    'area': AlertAreaV12;
    /**
     * 
     * @type {Array<CollectAlertsResponseAlertV12>}
     * @memberof CollectAlertsResponseAreaV12
     */
    'alerts': Array<CollectAlertsResponseAlertV12>;
}


/**
 * Alerts on given client. 
 * @export
 * @interface CollectAlertsResponseV12
 */
export interface CollectAlertsResponseV12 {
    /**
     * 
     * @type {Array<CollectAlertsResponseAreaV12>}
     * @memberof CollectAlertsResponseV12
     */
    'clientAlerts': Array<CollectAlertsResponseAreaV12>;
    /**
     * 
     * @type {number}
     * @memberof CollectAlertsResponseV12
     */
    'totalAlerts': number;
}
/**
 * company identifier
 * @export
 * @enum {string}
 */

export const CompanyIdEmployeeV5x0 = {
    BANK_EMPLOYEE: 'BANK_EMPLOYEE',
    PFS_CONSULTANT: 'PFS_CONSULTANT'
} as const;

export type CompanyIdEmployeeV5x0 = typeof CompanyIdEmployeeV5x0[keyof typeof CompanyIdEmployeeV5x0];


/**
 * company identifier
 * @export
 * @enum {string}
 */

export const CompanyIdV5x0 = {
    UNKNOWN: 'UNKNOWN',
    BANK: 'BANK',
    NONBANK: 'NONBANK',
    GEPARD: 'GEPARD',
    LOAN: 'LOAN',
    BANK_EMPLOYEE: 'BANK_EMPLOYEE',
    GROUP: 'GROUP',
    MOB_APP: 'MOB_APP',
    MOB_APP_SK: 'MOB_APP_SK',
    PFS: 'PFS',
    PFS_CONSULTANT: 'PFS_CONSULTANT',
    RENTEA: 'RENTEA',
    SFS: 'SFS',
    SIMPLEA: 'SIMPLEA',
    SIMPLEA_SK: 'SIMPLEA_SK',
    OCP: 'OCP',
    VUB: 'VUB',
    MOB_APP_PAR: 'MOB_APP_PAR',
    MOB_APP_SFS: 'MOB_APP_SFS',
    MOB_APP_WLB: 'MOB_APP_WLB'
} as const;

export type CompanyIdV5x0 = typeof CompanyIdV5x0[keyof typeof CompanyIdV5x0];


/**
 * 
 * @export
 * @interface ConsentAgreementHistoryItemV12
 */
export interface ConsentAgreementHistoryItemV12 {
    /**
     * 
     * @type {ConsentV11x0}
     * @memberof ConsentAgreementHistoryItemV12
     */
    'consent': ConsentV11x0;
    /**
     * 
     * @type {boolean}
     * @memberof ConsentAgreementHistoryItemV12
     */
    'agreed'?: boolean;
}


/**
 * 
 * @export
 * @interface ConsentAgreementHistoryRecordV12
 */
export interface ConsentAgreementHistoryRecordV12 {
    /**
     * Time of record creation. yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof ConsentAgreementHistoryRecordV12
     */
    'createdAt': string;
    /**
     * Full name of consultant (if \'createdByPid\' is PID UUID) otherwise null. Supplied by pid-core.
     * @type {string}
     * @memberof ConsentAgreementHistoryRecordV12
     */
    'createdBy'?: string;
    /**
     * Source consultant (either PID UUID or some general string)
     * @type {string}
     * @memberof ConsentAgreementHistoryRecordV12
     */
    'createdByPid': string;
    /**
     * Defines a source client of an event. Possible values: [\'CODE\' - (Description)] - WARNING: This list is not commitment! - Note, this list may not be complete, or values may get removed without any notification. [ \'UNKNOWN\' - (), \'NONBANK\' - (Not a BANK; Nebanka), \'BANK\' - (Partners bank company), \'BANK_EMPLOYEE\' - (Identification of PID being employee (consultant) of the BANK), \'BANK_TEST\' - (), \'GEPARD\' - (Gepard Finance), \'LOAN\' - (Loan applicant indication), \'MOB_APP\' - (Mobile application (CZE)), \'MOB_APP_PAR\' - (Mobile application (Partners), \'MOB_APP_SFS\' - (Mobile application (Simplea Financial Solutions), \'MOB_APP_SK\' - (Mobile application (SVK)), \'MOB_APP_WLB\' - (Mobile application (White Label Product)), \'OCP\' - (Shares trading; Obchod s cennymi papiry), \'ORFEUS\' - (Alternative to FIP in a PFS world), \'ORFEUS_SK\' - (Alternative to FIP in a SFS world), \'PFS\' - (Partners Financial Services (CZE)), \'PFS_CONSULTANT\' - (Identification of PID being employee (consultant) of the PFS), \'PID\' - (), \'PID_TEST\' - (), \'RENTEA\' - (a retirement company (CZE)), \'SFS\' - (Simplea Financial Services (SVK)), \'SIMPLEA\' - (an insurance company (CZE)), \'SIMPLEA_SK\' - (an insurance company (SVK)), \'VUB\' - (VUB Bank) ]
     * @type {string}
     * @memberof ConsentAgreementHistoryRecordV12
     */
    'sourceClient': string;
    /**
     * 
     * @type {TrustLevelV11x0}
     * @memberof ConsentAgreementHistoryRecordV12
     */
    'trustLevel': TrustLevelV11x0;
    /**
     * Type of verification - the source of operation like OCR + validation scan or manual consultant input. Possible values: [\'CODE\' - (Description)] - WARNING: This list is not commitment! - Note, this list may not be complete, or values may get removed without any notification. [ \'UNKNOWN\' - (), \'MACHINE\' - (), \'AML_OFFICER\' - (), \'BACKOFFICE_USER\' - (), \'BANK_ID\' - (), \'CLIENT\' - (), \'CONSULTANT_EDOKLAD\' - (), \'CONSULTANT_FACE_TO_FACE\' - (), \'CONSULTANT_REMOTE\' - (), \'SZR\' - (Abbreviation for Czech Basic Public Administration Registers - \'Sprava Zakladnich Registru\'), ]
     * @type {string}
     * @memberof ConsentAgreementHistoryRecordV12
     */
    'verificationType': string;
    /**
     * Full name of person or company identified by \'createdByPid\'. Resolved by pid-backoffice-gateway.
     * @type {string}
     * @memberof ConsentAgreementHistoryRecordV12
     */
    'fullName'?: string;
    /**
     * 
     * @type {ConsentAgreementHistoryItemV12}
     * @memberof ConsentAgreementHistoryRecordV12
     */
    'record': ConsentAgreementHistoryItemV12;
}


/**
 * 
 * @export
 * @interface ConsentAgreementHistoryRecordV12AllOf
 */
export interface ConsentAgreementHistoryRecordV12AllOf {
    /**
     * 
     * @type {ConsentAgreementHistoryItemV12}
     * @memberof ConsentAgreementHistoryRecordV12AllOf
     */
    'record': ConsentAgreementHistoryItemV12;
}
/**
 * 
 * @export
 * @interface ConsentAgreementHistoryResponseV12
 */
export interface ConsentAgreementHistoryResponseV12 {
    /**
     * 
     * @type {Array<ConsentAgreementHistoryRecordV12>}
     * @memberof ConsentAgreementHistoryResponseV12
     */
    'records': Array<ConsentAgreementHistoryRecordV12>;
}
/**
 * 
 * @export
 * @interface ConsentAgreementV12
 */
export interface ConsentAgreementV12 {
    /**
     * 
     * @type {ConsentV11x0}
     * @memberof ConsentAgreementV12
     */
    'consent': ConsentV11x0;
    /**
     * 
     * @type {boolean}
     * @memberof ConsentAgreementV12
     */
    'agreed': boolean;
}


/**
 * Consent
 * @export
 * @enum {string}
 */

export const ConsentV11x0 = {
    UNKNOWN: 'UNKNOWN',
    GDPR: 'GDPR',
    THIRD_PARTIES: 'THIRD_PARTIES',
    MOBILE_APP_TERMS_AND_CONDITIONS: 'MOBILE_APP_TERMS_AND_CONDITIONS',
    CHILD_ONBOARDING_MANDATE: 'CHILD_ONBOARDING_MANDATE'
} as const;

export type ConsentV11x0 = typeof ConsentV11x0[keyof typeof ConsentV11x0];


/**
 * Nationality, ISO 3166-1 format, subtype ALPHA-3. This means three letters in uppercase.
 * @export
 * @enum {string}
 */

export const CountryCodeV1x1 = {
    UNKNOWN: 'UNKNOWN',
    ABW: 'ABW',
    AFG: 'AFG',
    AGO: 'AGO',
    AIA: 'AIA',
    ALA: 'ALA',
    ALB: 'ALB',
    AND: 'AND',
    ARE: 'ARE',
    ARG: 'ARG',
    ARM: 'ARM',
    ASM: 'ASM',
    ATA: 'ATA',
    ATF: 'ATF',
    ATG: 'ATG',
    AUS: 'AUS',
    AUT: 'AUT',
    AZE: 'AZE',
    BDI: 'BDI',
    BEL: 'BEL',
    BEN: 'BEN',
    BES: 'BES',
    BFA: 'BFA',
    BGD: 'BGD',
    BGR: 'BGR',
    BHR: 'BHR',
    BHS: 'BHS',
    BIH: 'BIH',
    BLM: 'BLM',
    BLR: 'BLR',
    BLZ: 'BLZ',
    BMU: 'BMU',
    BOL: 'BOL',
    BRA: 'BRA',
    BRB: 'BRB',
    BRN: 'BRN',
    BTN: 'BTN',
    BVT: 'BVT',
    BWA: 'BWA',
    CAF: 'CAF',
    CAN: 'CAN',
    CCK: 'CCK',
    CHE: 'CHE',
    CHL: 'CHL',
    CHN: 'CHN',
    CIV: 'CIV',
    CMR: 'CMR',
    COD: 'COD',
    COG: 'COG',
    COK: 'COK',
    COL: 'COL',
    COM: 'COM',
    CPV: 'CPV',
    CRI: 'CRI',
    CUB: 'CUB',
    CUW: 'CUW',
    CXR: 'CXR',
    CYM: 'CYM',
    CYP: 'CYP',
    CZE: 'CZE',
    DEU: 'DEU',
    DJI: 'DJI',
    DMA: 'DMA',
    DNK: 'DNK',
    DOM: 'DOM',
    DZA: 'DZA',
    ECU: 'ECU',
    EGY: 'EGY',
    ERI: 'ERI',
    ESH: 'ESH',
    ESP: 'ESP',
    EST: 'EST',
    ETH: 'ETH',
    FIN: 'FIN',
    FJI: 'FJI',
    FLK: 'FLK',
    FRA: 'FRA',
    FRO: 'FRO',
    FSM: 'FSM',
    GAB: 'GAB',
    GBR: 'GBR',
    GEO: 'GEO',
    GGY: 'GGY',
    GHA: 'GHA',
    GIB: 'GIB',
    GIN: 'GIN',
    GLP: 'GLP',
    GMB: 'GMB',
    GNB: 'GNB',
    GNQ: 'GNQ',
    GRC: 'GRC',
    GRD: 'GRD',
    GRL: 'GRL',
    GTM: 'GTM',
    GUF: 'GUF',
    GUM: 'GUM',
    GUY: 'GUY',
    HKG: 'HKG',
    HMD: 'HMD',
    HND: 'HND',
    HRV: 'HRV',
    HTI: 'HTI',
    HUN: 'HUN',
    IDN: 'IDN',
    IMN: 'IMN',
    IND: 'IND',
    IOT: 'IOT',
    IRL: 'IRL',
    IRN: 'IRN',
    IRQ: 'IRQ',
    ISL: 'ISL',
    ISR: 'ISR',
    ITA: 'ITA',
    JAM: 'JAM',
    JEY: 'JEY',
    JOR: 'JOR',
    JPN: 'JPN',
    KAZ: 'KAZ',
    KEN: 'KEN',
    KGZ: 'KGZ',
    KHM: 'KHM',
    KIR: 'KIR',
    KNA: 'KNA',
    KOR: 'KOR',
    KSV: 'KSV',
    KWT: 'KWT',
    LAO: 'LAO',
    LBN: 'LBN',
    LBR: 'LBR',
    LBY: 'LBY',
    LCA: 'LCA',
    LIE: 'LIE',
    LKA: 'LKA',
    LSO: 'LSO',
    LTU: 'LTU',
    LUX: 'LUX',
    LVA: 'LVA',
    MAC: 'MAC',
    MAF: 'MAF',
    MAR: 'MAR',
    MCO: 'MCO',
    MDA: 'MDA',
    MDG: 'MDG',
    MDV: 'MDV',
    MEX: 'MEX',
    MHL: 'MHL',
    MKD: 'MKD',
    MLI: 'MLI',
    MLT: 'MLT',
    MMR: 'MMR',
    MNE: 'MNE',
    MNG: 'MNG',
    MNP: 'MNP',
    MOZ: 'MOZ',
    MRT: 'MRT',
    MSR: 'MSR',
    MTQ: 'MTQ',
    MUS: 'MUS',
    MWI: 'MWI',
    MYS: 'MYS',
    MYT: 'MYT',
    NAM: 'NAM',
    NCL: 'NCL',
    NER: 'NER',
    NFK: 'NFK',
    NGA: 'NGA',
    NIC: 'NIC',
    NIU: 'NIU',
    NLD: 'NLD',
    NOR: 'NOR',
    NPL: 'NPL',
    NRU: 'NRU',
    NZL: 'NZL',
    OMN: 'OMN',
    PAK: 'PAK',
    PAN: 'PAN',
    PCN: 'PCN',
    PER: 'PER',
    PHL: 'PHL',
    PLW: 'PLW',
    PNG: 'PNG',
    POL: 'POL',
    PRI: 'PRI',
    PRK: 'PRK',
    PRT: 'PRT',
    PRY: 'PRY',
    PSE: 'PSE',
    PYF: 'PYF',
    QAT: 'QAT',
    REU: 'REU',
    ROU: 'ROU',
    RUS: 'RUS',
    RWA: 'RWA',
    SAU: 'SAU',
    SDN: 'SDN',
    SEN: 'SEN',
    SGP: 'SGP',
    SGS: 'SGS',
    SHN: 'SHN',
    SJM: 'SJM',
    SLB: 'SLB',
    SLE: 'SLE',
    SLV: 'SLV',
    SMR: 'SMR',
    SOM: 'SOM',
    SPM: 'SPM',
    SRB: 'SRB',
    SSD: 'SSD',
    STP: 'STP',
    SUR: 'SUR',
    SVK: 'SVK',
    SVN: 'SVN',
    SWE: 'SWE',
    SWZ: 'SWZ',
    SXM: 'SXM',
    SYC: 'SYC',
    SYR: 'SYR',
    TCA: 'TCA',
    TCD: 'TCD',
    TGO: 'TGO',
    THA: 'THA',
    TJK: 'TJK',
    TKL: 'TKL',
    TKM: 'TKM',
    TLS: 'TLS',
    TON: 'TON',
    TTO: 'TTO',
    TUN: 'TUN',
    TUR: 'TUR',
    TUV: 'TUV',
    TWN: 'TWN',
    TZA: 'TZA',
    UGA: 'UGA',
    UKR: 'UKR',
    UMI: 'UMI',
    URY: 'URY',
    USA: 'USA',
    UZB: 'UZB',
    VAT: 'VAT',
    VCT: 'VCT',
    VEN: 'VEN',
    VGB: 'VGB',
    VIR: 'VIR',
    VNM: 'VNM',
    VUT: 'VUT',
    WLF: 'WLF',
    WSM: 'WSM',
    YEM: 'YEM',
    ZAF: 'ZAF',
    ZMB: 'ZMB',
    ZWE: 'ZWE'
} as const;

export type CountryCodeV1x1 = typeof CountryCodeV1x1[keyof typeof CountryCodeV1x1];


/**
 * Personal databox created under in a government system
 * @export
 * @interface DataboxV11x0
 */
export interface DataboxV11x0 {
    /**
     * Identification of databox containing 7 characters
     * @type {string}
     * @memberof DataboxV11x0
     */
    'databoxId': string;
    /**
     * Defines a databox type. Possible values: [\'CODE\' - (Description)] - WARNING: This list is not commitment! - Note, this list may not be complete, or values may get removed without any notification. [ \'OVM\' - (Orgán veřejné moci), \'OVM_FO\' - (Fyzická osoba, která je v roli OVM), \'OVM_PFO\' - (Podnikající fyzická osoba, která je v roli OVM), \'OVM_PO\' - (Právnická osoba v roli OVM), \'PO\' - (Právnická osoba zapsaná v registru osob), \'PFO\' - (Podnikající fyzická osoba), \'PFO_ADVOK\' - (Podnikající fyzická osoba - advokát), \'PFO_DANPOR\' - (Podnikající fyzická osoba - daňový poradce), \'PFO_INSSPR\' - (Podnikající fyzická osoba - insolvenční správce), \'PFO_AUDITOR\' - (Podnikající fyzická osoba - statutární auditor (OSVČ nebo zaměstnanec)), \'PFO_ZNALEC\' - (Podnikající fyzická osoba - znalec), \'PFO_TLUMOCNIK\' - (Podnikající fyzická osoba - soudní překladatel nebo tlumočník), \'PFO_ARCH\' - (Podnikající fyzická osoba - architekt), \'PFO_AIAT \' - (Podnikající fyzická osoba - autorizovaný inženýr / technik), \'PFO_AZI \' - (Podnikající fyzická osoba - autorizovaný zeměměřický inženýr), \'FO\' - (Fyzická osoba), \'PFO_REQ\' - (Podnikající fyzická osoba - na žádost), \'PO_REQ\' - (Právnická osoba - na žádost), \'OVM_REQ\' - (Schránka OVM zřízená na žádost), ]
     * @type {string}
     * @memberof DataboxV11x0
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface DeviceDetailV12
 */
export interface DeviceDetailV12 {
    /**
     * 
     * @type {string}
     * @memberof DeviceDetailV12
     */
    'deviceUuid': string;
    /**
     * 
     * @type {string}
     * @memberof DeviceDetailV12
     */
    'deviceFingerprint': string;
    /**
     * 
     * @type {string}
     * @memberof DeviceDetailV12
     */
    'name': string;
    /**
     * 
     * @type {DeviceStatusV12}
     * @memberof DeviceDetailV12
     */
    'status': DeviceStatusV12;
    /**
     * 
     * @type {string}
     * @memberof DeviceDetailV12
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof DeviceDetailV12
     */
    'lastUsed': string;
    /**
     * 
     * @type {string}
     * @memberof DeviceDetailV12
     */
    'appVersion': string;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceDetailV12
     */
    'notificationsEnabled': boolean;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const DeviceStatusV12 = {
    ACTIVE: 'ACTIVE',
    BLOCKED: 'BLOCKED',
    REMOVED: 'REMOVED',
    CREATED: 'CREATED',
    PENDING_COMMIT: 'PENDING_COMMIT'
} as const;

export type DeviceStatusV12 = typeof DeviceStatusV12[keyof typeof DeviceStatusV12];


/**
 * 
 * @export
 * @interface EmailHistoryItemV12
 */
export interface EmailHistoryItemV12 {
    /**
     * 
     * @type {EmailV11x0}
     * @memberof EmailHistoryItemV12
     */
    'email': EmailV11x0;
    /**
     * 
     * @type {boolean}
     * @memberof EmailHistoryItemV12
     */
    'primary': boolean;
}
/**
 * 
 * @export
 * @interface EmailHistoryRecordV12
 */
export interface EmailHistoryRecordV12 {
    /**
     * Time of record creation. yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof EmailHistoryRecordV12
     */
    'createdAt': string;
    /**
     * Full name of consultant (if \'createdByPid\' is PID UUID) otherwise null. Supplied by pid-core.
     * @type {string}
     * @memberof EmailHistoryRecordV12
     */
    'createdBy'?: string;
    /**
     * Source consultant (either PID UUID or some general string)
     * @type {string}
     * @memberof EmailHistoryRecordV12
     */
    'createdByPid': string;
    /**
     * Defines a source client of an event. Possible values: [\'CODE\' - (Description)] - WARNING: This list is not commitment! - Note, this list may not be complete, or values may get removed without any notification. [ \'UNKNOWN\' - (), \'NONBANK\' - (Not a BANK; Nebanka), \'BANK\' - (Partners bank company), \'BANK_EMPLOYEE\' - (Identification of PID being employee (consultant) of the BANK), \'BANK_TEST\' - (), \'GEPARD\' - (Gepard Finance), \'LOAN\' - (Loan applicant indication), \'MOB_APP\' - (Mobile application (CZE)), \'MOB_APP_PAR\' - (Mobile application (Partners), \'MOB_APP_SFS\' - (Mobile application (Simplea Financial Solutions), \'MOB_APP_SK\' - (Mobile application (SVK)), \'MOB_APP_WLB\' - (Mobile application (White Label Product)), \'OCP\' - (Shares trading; Obchod s cennymi papiry), \'ORFEUS\' - (Alternative to FIP in a PFS world), \'ORFEUS_SK\' - (Alternative to FIP in a SFS world), \'PFS\' - (Partners Financial Services (CZE)), \'PFS_CONSULTANT\' - (Identification of PID being employee (consultant) of the PFS), \'PID\' - (), \'PID_TEST\' - (), \'RENTEA\' - (a retirement company (CZE)), \'SFS\' - (Simplea Financial Services (SVK)), \'SIMPLEA\' - (an insurance company (CZE)), \'SIMPLEA_SK\' - (an insurance company (SVK)), \'VUB\' - (VUB Bank) ]
     * @type {string}
     * @memberof EmailHistoryRecordV12
     */
    'sourceClient': string;
    /**
     * 
     * @type {TrustLevelV11x0}
     * @memberof EmailHistoryRecordV12
     */
    'trustLevel': TrustLevelV11x0;
    /**
     * Type of verification - the source of operation like OCR + validation scan or manual consultant input. Possible values: [\'CODE\' - (Description)] - WARNING: This list is not commitment! - Note, this list may not be complete, or values may get removed without any notification. [ \'UNKNOWN\' - (), \'MACHINE\' - (), \'AML_OFFICER\' - (), \'BACKOFFICE_USER\' - (), \'BANK_ID\' - (), \'CLIENT\' - (), \'CONSULTANT_EDOKLAD\' - (), \'CONSULTANT_FACE_TO_FACE\' - (), \'CONSULTANT_REMOTE\' - (), \'SZR\' - (Abbreviation for Czech Basic Public Administration Registers - \'Sprava Zakladnich Registru\'), ]
     * @type {string}
     * @memberof EmailHistoryRecordV12
     */
    'verificationType': string;
    /**
     * Full name of person or company identified by \'createdByPid\'. Resolved by pid-backoffice-gateway.
     * @type {string}
     * @memberof EmailHistoryRecordV12
     */
    'fullName'?: string;
    /**
     * 
     * @type {EmailHistoryItemV12}
     * @memberof EmailHistoryRecordV12
     */
    'record': EmailHistoryItemV12;
}


/**
 * 
 * @export
 * @interface EmailHistoryRecordV12AllOf
 */
export interface EmailHistoryRecordV12AllOf {
    /**
     * 
     * @type {EmailHistoryItemV12}
     * @memberof EmailHistoryRecordV12AllOf
     */
    'record': EmailHistoryItemV12;
}
/**
 * 
 * @export
 * @interface EmailHistoryResponseV12
 */
export interface EmailHistoryResponseV12 {
    /**
     * 
     * @type {Array<EmailHistoryRecordV12>}
     * @memberof EmailHistoryResponseV12
     */
    'records': Array<EmailHistoryRecordV12>;
}
/**
 * A class represents email
 * @export
 * @interface EmailV11x0
 */
export interface EmailV11x0 {
    /**
     * End-User\'s preferred e-mail address. Its value MUST conform to the RFC 5322 [RFC5322] addr-spec syntax. The API consumer MUST NOT rely upon this value being unique.
     * @type {string}
     * @memberof EmailV11x0
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface EmployeeFlagV5x0
 */
export interface EmployeeFlagV5x0 {
    /**
     * 
     * @type {boolean}
     * @memberof EmployeeFlagV5x0
     */
    'active': boolean;
    /**
     * 
     * @type {Array<CompanyIdEmployeeV5x0>}
     * @memberof EmployeeFlagV5x0
     */
    'companies'?: Array<CompanyIdEmployeeV5x0>;
}
/**
 * 
 * @export
 * @interface FindClientAdvisorResponseV12
 */
export interface FindClientAdvisorResponseV12 {
    /**
     * 
     * @type {FindClientAdvisorResponseV12Advisor}
     * @memberof FindClientAdvisorResponseV12
     */
    'advisor'?: FindClientAdvisorResponseV12Advisor;
}
/**
 * 
 * @export
 * @interface FindClientAdvisorResponseV12Advisor
 */
export interface FindClientAdvisorResponseV12Advisor {
    /**
     * 
     * @type {number}
     * @memberof FindClientAdvisorResponseV12Advisor
     */
    'id': number;
    /**
     * 
     * @type {AdvisorDetailIdAndNameV12}
     * @memberof FindClientAdvisorResponseV12Advisor
     */
    'level'?: AdvisorDetailIdAndNameV12;
    /**
     * 
     * @type {AdvisorDetailIdAndNameV12}
     * @memberof FindClientAdvisorResponseV12Advisor
     */
    'function'?: AdvisorDetailIdAndNameV12;
    /**
     * 
     * @type {AdvisorDetailNameV12}
     * @memberof FindClientAdvisorResponseV12Advisor
     */
    'name'?: AdvisorDetailNameV12;
    /**
     * 
     * @type {AdvisorDetailTitleV12}
     * @memberof FindClientAdvisorResponseV12Advisor
     */
    'titles'?: AdvisorDetailTitleV12;
    /**
     * 
     * @type {string}
     * @memberof FindClientAdvisorResponseV12Advisor
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof FindClientAdvisorResponseV12Advisor
     */
    'email'?: string;
    /**
     * 
     * @type {AdvisorDetailIdAndNameV12}
     * @memberof FindClientAdvisorResponseV12Advisor
     */
    'type'?: AdvisorDetailIdAndNameV12;
    /**
     * 
     * @type {AdvisorDetailAddressV12}
     * @memberof FindClientAdvisorResponseV12Advisor
     */
    'address'?: AdvisorDetailAddressV12;
    /**
     * 
     * @type {AdvisorDetailPhotoV12}
     * @memberof FindClientAdvisorResponseV12Advisor
     */
    'photo'?: AdvisorDetailPhotoV12;
}
/**
 * 
 * @export
 * @interface FindClientDevicesResponseV12
 */
export interface FindClientDevicesResponseV12 {
    /**
     * 
     * @type {Array<DeviceDetailV12>}
     * @memberof FindClientDevicesResponseV12
     */
    'devices': Array<DeviceDetailV12>;
}
/**
 * Male or female, unknown in a case of an internal issue.
 * @export
 * @enum {string}
 */

export const GenderV11x0 = {
    MALE: 'MALE',
    FEMALE: 'FEMALE',
    UNKNOWN: 'UNKNOWN'
} as const;

export type GenderV11x0 = typeof GenderV11x0[keyof typeof GenderV11x0];


/**
 * Common properties of all history records.
 * @export
 * @interface HistoryRecordV12
 */
export interface HistoryRecordV12 {
    /**
     * Time of record creation. yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof HistoryRecordV12
     */
    'createdAt': string;
    /**
     * Full name of consultant (if \'createdByPid\' is PID UUID) otherwise null. Supplied by pid-core.
     * @type {string}
     * @memberof HistoryRecordV12
     */
    'createdBy'?: string;
    /**
     * Source consultant (either PID UUID or some general string)
     * @type {string}
     * @memberof HistoryRecordV12
     */
    'createdByPid': string;
    /**
     * Defines a source client of an event. Possible values: [\'CODE\' - (Description)] - WARNING: This list is not commitment! - Note, this list may not be complete, or values may get removed without any notification. [ \'UNKNOWN\' - (), \'NONBANK\' - (Not a BANK; Nebanka), \'BANK\' - (Partners bank company), \'BANK_EMPLOYEE\' - (Identification of PID being employee (consultant) of the BANK), \'BANK_TEST\' - (), \'GEPARD\' - (Gepard Finance), \'LOAN\' - (Loan applicant indication), \'MOB_APP\' - (Mobile application (CZE)), \'MOB_APP_PAR\' - (Mobile application (Partners), \'MOB_APP_SFS\' - (Mobile application (Simplea Financial Solutions), \'MOB_APP_SK\' - (Mobile application (SVK)), \'MOB_APP_WLB\' - (Mobile application (White Label Product)), \'OCP\' - (Shares trading; Obchod s cennymi papiry), \'ORFEUS\' - (Alternative to FIP in a PFS world), \'ORFEUS_SK\' - (Alternative to FIP in a SFS world), \'PFS\' - (Partners Financial Services (CZE)), \'PFS_CONSULTANT\' - (Identification of PID being employee (consultant) of the PFS), \'PID\' - (), \'PID_TEST\' - (), \'RENTEA\' - (a retirement company (CZE)), \'SFS\' - (Simplea Financial Services (SVK)), \'SIMPLEA\' - (an insurance company (CZE)), \'SIMPLEA_SK\' - (an insurance company (SVK)), \'VUB\' - (VUB Bank) ]
     * @type {string}
     * @memberof HistoryRecordV12
     */
    'sourceClient': string;
    /**
     * 
     * @type {TrustLevelV11x0}
     * @memberof HistoryRecordV12
     */
    'trustLevel': TrustLevelV11x0;
    /**
     * Type of verification - the source of operation like OCR + validation scan or manual consultant input. Possible values: [\'CODE\' - (Description)] - WARNING: This list is not commitment! - Note, this list may not be complete, or values may get removed without any notification. [ \'UNKNOWN\' - (), \'MACHINE\' - (), \'AML_OFFICER\' - (), \'BACKOFFICE_USER\' - (), \'BANK_ID\' - (), \'CLIENT\' - (), \'CONSULTANT_EDOKLAD\' - (), \'CONSULTANT_FACE_TO_FACE\' - (), \'CONSULTANT_REMOTE\' - (), \'SZR\' - (Abbreviation for Czech Basic Public Administration Registers - \'Sprava Zakladnich Registru\'), ]
     * @type {string}
     * @memberof HistoryRecordV12
     */
    'verificationType': string;
    /**
     * Full name of person or company identified by \'createdByPid\'. Resolved by pid-backoffice-gateway.
     * @type {string}
     * @memberof HistoryRecordV12
     */
    'fullName'?: string;
}


/**
 * 
 * @export
 * @interface IdCardHistoryRecordV12
 */
export interface IdCardHistoryRecordV12 {
    /**
     * Time of record creation. yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof IdCardHistoryRecordV12
     */
    'createdAt': string;
    /**
     * Full name of consultant (if \'createdByPid\' is PID UUID) otherwise null. Supplied by pid-core.
     * @type {string}
     * @memberof IdCardHistoryRecordV12
     */
    'createdBy'?: string;
    /**
     * Source consultant (either PID UUID or some general string)
     * @type {string}
     * @memberof IdCardHistoryRecordV12
     */
    'createdByPid': string;
    /**
     * Defines a source client of an event. Possible values: [\'CODE\' - (Description)] - WARNING: This list is not commitment! - Note, this list may not be complete, or values may get removed without any notification. [ \'UNKNOWN\' - (), \'NONBANK\' - (Not a BANK; Nebanka), \'BANK\' - (Partners bank company), \'BANK_EMPLOYEE\' - (Identification of PID being employee (consultant) of the BANK), \'BANK_TEST\' - (), \'GEPARD\' - (Gepard Finance), \'LOAN\' - (Loan applicant indication), \'MOB_APP\' - (Mobile application (CZE)), \'MOB_APP_PAR\' - (Mobile application (Partners), \'MOB_APP_SFS\' - (Mobile application (Simplea Financial Solutions), \'MOB_APP_SK\' - (Mobile application (SVK)), \'MOB_APP_WLB\' - (Mobile application (White Label Product)), \'OCP\' - (Shares trading; Obchod s cennymi papiry), \'ORFEUS\' - (Alternative to FIP in a PFS world), \'ORFEUS_SK\' - (Alternative to FIP in a SFS world), \'PFS\' - (Partners Financial Services (CZE)), \'PFS_CONSULTANT\' - (Identification of PID being employee (consultant) of the PFS), \'PID\' - (), \'PID_TEST\' - (), \'RENTEA\' - (a retirement company (CZE)), \'SFS\' - (Simplea Financial Services (SVK)), \'SIMPLEA\' - (an insurance company (CZE)), \'SIMPLEA_SK\' - (an insurance company (SVK)), \'VUB\' - (VUB Bank) ]
     * @type {string}
     * @memberof IdCardHistoryRecordV12
     */
    'sourceClient': string;
    /**
     * 
     * @type {TrustLevelV11x0}
     * @memberof IdCardHistoryRecordV12
     */
    'trustLevel': TrustLevelV11x0;
    /**
     * Type of verification - the source of operation like OCR + validation scan or manual consultant input. Possible values: [\'CODE\' - (Description)] - WARNING: This list is not commitment! - Note, this list may not be complete, or values may get removed without any notification. [ \'UNKNOWN\' - (), \'MACHINE\' - (), \'AML_OFFICER\' - (), \'BACKOFFICE_USER\' - (), \'BANK_ID\' - (), \'CLIENT\' - (), \'CONSULTANT_EDOKLAD\' - (), \'CONSULTANT_FACE_TO_FACE\' - (), \'CONSULTANT_REMOTE\' - (), \'SZR\' - (Abbreviation for Czech Basic Public Administration Registers - \'Sprava Zakladnich Registru\'), ]
     * @type {string}
     * @memberof IdCardHistoryRecordV12
     */
    'verificationType': string;
    /**
     * Full name of person or company identified by \'createdByPid\'. Resolved by pid-backoffice-gateway.
     * @type {string}
     * @memberof IdCardHistoryRecordV12
     */
    'fullName'?: string;
    /**
     * 
     * @type {IdCardV12}
     * @memberof IdCardHistoryRecordV12
     */
    'record': IdCardV12;
}


/**
 * 
 * @export
 * @interface IdCardHistoryRecordV12AllOf
 */
export interface IdCardHistoryRecordV12AllOf {
    /**
     * 
     * @type {IdCardV12}
     * @memberof IdCardHistoryRecordV12AllOf
     */
    'record': IdCardV12;
}
/**
 * 
 * @export
 * @interface IdCardHistoryResponseV12
 */
export interface IdCardHistoryResponseV12 {
    /**
     * 
     * @type {Array<IdCardHistoryRecordV12>}
     * @memberof IdCardHistoryResponseV12
     */
    'records': Array<IdCardHistoryRecordV12>;
}
/**
 * ID card type
 * @export
 * @enum {string}
 */

export const IdCardTypeV11x0 = {
    ID: 'ID',
    OP: 'OP',
    P: 'P',
    CA: 'CA',
    DL: 'DL',
    IR: 'IR',
    BC: 'BC',
    VS: 'VS',
    PS: 'PS',
    IX: 'IX',
    IE: 'IE',
    UNKNOWN: 'UNKNOWN'
} as const;

export type IdCardTypeV11x0 = typeof IdCardTypeV11x0[keyof typeof IdCardTypeV11x0];


/**
 * Client personal ID Card.
 * @export
 * @interface IdCardV12
 */
export interface IdCardV12 {
    /**
     * 
     * @type {IdCardTypeV11x0}
     * @memberof IdCardV12
     */
    'type': IdCardTypeV11x0;
    /**
     * 
     * @type {CountryCodeV1x1}
     * @memberof IdCardV12
     */
    'country': CountryCodeV1x1;
    /**
     * 
     * @type {string}
     * @memberof IdCardV12
     */
    'number': string;
    /**
     * 
     * @type {string}
     * @memberof IdCardV12
     */
    'validTo'?: string;
    /**
     * 
     * @type {string}
     * @memberof IdCardV12
     */
    'issuer': string;
    /**
     * 
     * @type {string}
     * @memberof IdCardV12
     */
    'issueDate'?: string;
    /**
     * Investigation id from ZenId.
     * @type {string}
     * @memberof IdCardV12
     */
    'investigationId'?: string | null;
}


/**
 * Code of irregular income.
 * @export
 * @enum {string}
 */

export const IrregularIncomeEsaCodeV5x0 = {
    UNKNOWN: 'UNKNOWN',
    COMPANY_SHARE_SALE: 'COMPANY_SHARE_SALE',
    REAL_ESTATE_SALE: 'REAL_ESTATE_SALE',
    MOVABLE_ITEM_SALE: 'MOVABLE_ITEM_SALE',
    GIFT: 'GIFT',
    HERITAGE: 'HERITAGE',
    PRIZE: 'PRIZE',
    LOAN_FROM_FINANCIAL_INSTITUTION: 'LOAN_FROM_FINANCIAL_INSTITUTION',
    LOAN_OTHER: 'LOAN_OTHER',
    PERSONAL_SAVINGS: 'PERSONAL_SAVINGS',
    INVESTMENT_PRODUCTS_INCOME: 'INVESTMENT_PRODUCTS_INCOME',
    OTHER_INCOME: 'OTHER_INCOME'
} as const;

export type IrregularIncomeEsaCodeV5x0 = typeof IrregularIncomeEsaCodeV5x0[keyof typeof IrregularIncomeEsaCodeV5x0];


/**
 * 
 * @export
 * @interface LastViewedClientsResponseV12
 */
export interface LastViewedClientsResponseV12 {
    /**
     * 
     * @type {Array<ClientDetailV12>}
     * @memberof LastViewedClientsResponseV12
     */
    'clients': Array<ClientDetailV12>;
}
/**
 * Client marital status.
 * @export
 * @enum {string}
 */

export const MaritalStatusV11x0 = {
    COHABITATION: 'COHABITATION',
    MARRIED: 'MARRIED',
    DIVORCED: 'DIVORCED',
    LAPSED_MARRIAGE: 'LAPSED_MARRIAGE',
    REGISTERED_PARTNERSHIP: 'REGISTERED_PARTNERSHIP',
    REGISTERED_PARTNERSHIP_CANCELED: 'REGISTERED_PARTNERSHIP_CANCELED',
    REGISTERED_PARTNERSHIP_WIDOWED: 'REGISTERED_PARTNERSHIP_WIDOWED',
    PARTNERSHIP: 'PARTNERSHIP',
    PARTNERSHIP_CANCELED: 'PARTNERSHIP_CANCELED',
    WIDOWED: 'WIDOWED',
    SEPARATED: 'SEPARATED',
    SINGLE: 'SINGLE',
    UNKNOWN: 'UNKNOWN'
} as const;

export type MaritalStatusV11x0 = typeof MaritalStatusV11x0[keyof typeof MaritalStatusV11x0];


/**
 * 
 * @export
 * @interface NaceCodeV12
 */
export interface NaceCodeV12 {
    /**
     * NACE code.
     * @type {string}
     * @memberof NaceCodeV12
     */
    'code': string;
    /**
     * NACE code description.
     * @type {string}
     * @memberof NaceCodeV12
     */
    'description': string;
}
/**
 * 
 * @export
 * @interface NationalNumberHistoryRecordV12
 */
export interface NationalNumberHistoryRecordV12 {
    /**
     * Time of record creation. yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof NationalNumberHistoryRecordV12
     */
    'createdAt': string;
    /**
     * Full name of consultant (if \'createdByPid\' is PID UUID) otherwise null. Supplied by pid-core.
     * @type {string}
     * @memberof NationalNumberHistoryRecordV12
     */
    'createdBy'?: string;
    /**
     * Source consultant (either PID UUID or some general string)
     * @type {string}
     * @memberof NationalNumberHistoryRecordV12
     */
    'createdByPid': string;
    /**
     * Defines a source client of an event. Possible values: [\'CODE\' - (Description)] - WARNING: This list is not commitment! - Note, this list may not be complete, or values may get removed without any notification. [ \'UNKNOWN\' - (), \'NONBANK\' - (Not a BANK; Nebanka), \'BANK\' - (Partners bank company), \'BANK_EMPLOYEE\' - (Identification of PID being employee (consultant) of the BANK), \'BANK_TEST\' - (), \'GEPARD\' - (Gepard Finance), \'LOAN\' - (Loan applicant indication), \'MOB_APP\' - (Mobile application (CZE)), \'MOB_APP_PAR\' - (Mobile application (Partners), \'MOB_APP_SFS\' - (Mobile application (Simplea Financial Solutions), \'MOB_APP_SK\' - (Mobile application (SVK)), \'MOB_APP_WLB\' - (Mobile application (White Label Product)), \'OCP\' - (Shares trading; Obchod s cennymi papiry), \'ORFEUS\' - (Alternative to FIP in a PFS world), \'ORFEUS_SK\' - (Alternative to FIP in a SFS world), \'PFS\' - (Partners Financial Services (CZE)), \'PFS_CONSULTANT\' - (Identification of PID being employee (consultant) of the PFS), \'PID\' - (), \'PID_TEST\' - (), \'RENTEA\' - (a retirement company (CZE)), \'SFS\' - (Simplea Financial Services (SVK)), \'SIMPLEA\' - (an insurance company (CZE)), \'SIMPLEA_SK\' - (an insurance company (SVK)), \'VUB\' - (VUB Bank) ]
     * @type {string}
     * @memberof NationalNumberHistoryRecordV12
     */
    'sourceClient': string;
    /**
     * 
     * @type {TrustLevelV11x0}
     * @memberof NationalNumberHistoryRecordV12
     */
    'trustLevel': TrustLevelV11x0;
    /**
     * Type of verification - the source of operation like OCR + validation scan or manual consultant input. Possible values: [\'CODE\' - (Description)] - WARNING: This list is not commitment! - Note, this list may not be complete, or values may get removed without any notification. [ \'UNKNOWN\' - (), \'MACHINE\' - (), \'AML_OFFICER\' - (), \'BACKOFFICE_USER\' - (), \'BANK_ID\' - (), \'CLIENT\' - (), \'CONSULTANT_EDOKLAD\' - (), \'CONSULTANT_FACE_TO_FACE\' - (), \'CONSULTANT_REMOTE\' - (), \'SZR\' - (Abbreviation for Czech Basic Public Administration Registers - \'Sprava Zakladnich Registru\'), ]
     * @type {string}
     * @memberof NationalNumberHistoryRecordV12
     */
    'verificationType': string;
    /**
     * Full name of person or company identified by \'createdByPid\'. Resolved by pid-backoffice-gateway.
     * @type {string}
     * @memberof NationalNumberHistoryRecordV12
     */
    'fullName'?: string;
    /**
     * 
     * @type {NationalNumberV11x0}
     * @memberof NationalNumberHistoryRecordV12
     */
    'record': NationalNumberV11x0;
}


/**
 * 
 * @export
 * @interface NationalNumberHistoryRecordV12AllOf
 */
export interface NationalNumberHistoryRecordV12AllOf {
    /**
     * 
     * @type {NationalNumberV11x0}
     * @memberof NationalNumberHistoryRecordV12AllOf
     */
    'record': NationalNumberV11x0;
}
/**
 * 
 * @export
 * @interface NationalNumberHistoryResponseV12
 */
export interface NationalNumberHistoryResponseV12 {
    /**
     * 
     * @type {Array<NationalNumberHistoryRecordV12>}
     * @memberof NationalNumberHistoryResponseV12
     */
    'records': Array<NationalNumberHistoryRecordV12>;
}
/**
 * Unique national identifier
 * @export
 * @interface NationalNumberV11x0
 */
export interface NationalNumberV11x0 {
    /**
     * User\'s number like birth number
     * @type {string}
     * @memberof NationalNumberV11x0
     */
    'number': string;
    /**
     * 
     * @type {CountryCodeV1x1}
     * @memberof NationalNumberV11x0
     */
    'country': CountryCodeV1x1;
    /**
     * Type of national number. Possible values: [\'CODE\' - (Description)] - WARNING: This list is not commitment! - Note, this list may not be complete, or values may get removed without any notification. [ \'UNKNOWN\' - (), \'UNSPECIFIED\' - (), \'NATIONAL_ID\' - (like birth number), \'INSURANCE_NUMBER\' - (), ]
     * @type {string}
     * @memberof NationalNumberV11x0
     */
    'type': string;
}


/**
 * 
 * @export
 * @interface NewActivationsBlockageInfoActionsV12
 */
export interface NewActivationsBlockageInfoActionsV12 {
    /**
     * 
     * @type {boolean}
     * @memberof NewActivationsBlockageInfoActionsV12
     */
    'block': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NewActivationsBlockageInfoActionsV12
     */
    'unblock': boolean;
}
/**
 * 
 * @export
 * @interface NewActivationsBlockageInfoV12
 */
export interface NewActivationsBlockageInfoV12 {
    /**
     * Whether client\'s new activations are blocked.
     * @type {boolean}
     * @memberof NewActivationsBlockageInfoV12
     */
    'blocked': boolean;
    /**
     * 
     * @type {NewActivationsBlockageInfoActionsV12}
     * @memberof NewActivationsBlockageInfoV12
     */
    'actions': NewActivationsBlockageInfoActionsV12;
}
/**
 * Pagaeble object used for searching. Returns the state of pagination.
 * @export
 * @interface PageableResponseV1x0
 */
export interface PageableResponseV1x0 {
    /**
     * Number of the page.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'pageNumber': number;
    /**
     * Number of records per page.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'pageSize': number;
    /**
     * Total number of pages with this page size.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'totalPages': number;
    /**
     * Total size of all records.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'totalSize': number;
}
/**
 * Object for search paging.
 * @export
 * @interface PageableV1x0
 */
export interface PageableV1x0 {
    /**
     * Number of the page.
     * @type {number}
     * @memberof PageableV1x0
     */
    'pageNumber': number;
    /**
     * Maximum number of records per page.
     * @type {number}
     * @memberof PageableV1x0
     */
    'pageSize': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PartnersEmployeeTypeV5x0 = {
    BANK_CONTRACTOR: 'BANK_CONTRACTOR',
    BANK_EMPLOYEE: 'BANK_EMPLOYEE',
    SIMPLEA_CONTRACTOR: 'SIMPLEA_CONTRACTOR',
    SIMPLEA_EMPLOYEE: 'SIMPLEA_EMPLOYEE',
    RENTEA_CONTRACTOR: 'RENTEA_CONTRACTOR',
    RENTEA_EMPLOYEE: 'RENTEA_EMPLOYEE',
    TRIGEA_CONTRACTOR: 'TRIGEA_CONTRACTOR',
    TRIGEA_EMPLOYEE: 'TRIGEA_EMPLOYEE',
    PFS_CONTRACTOR: 'PFS_CONTRACTOR',
    PFS_EMPLOYEE: 'PFS_EMPLOYEE',
    PIS_CONTRACTOR: 'PIS_CONTRACTOR',
    PIS_EMPLOYEE: 'PIS_EMPLOYEE',
    PBK_CONTRACTOR: 'PBK_CONTRACTOR',
    PBK_EMPLOYEE: 'PBK_EMPLOYEE',
    MEDIA_CONTRACTOR: 'MEDIA_CONTRACTOR',
    MEDIA_EMPLOYEE: 'MEDIA_EMPLOYEE'
} as const;

export type PartnersEmployeeTypeV5x0 = typeof PartnersEmployeeTypeV5x0[keyof typeof PartnersEmployeeTypeV5x0];


/**
 * 
 * @export
 * @interface PartnersEmployeeWrapperV12
 */
export interface PartnersEmployeeWrapperV12 {
    /**
     * 
     * @type {boolean}
     * @memberof PartnersEmployeeWrapperV12
     */
    'isPartnersEmployee': boolean;
    /**
     * 
     * @type {Array<CompanyIdV5x0>}
     * @memberof PartnersEmployeeWrapperV12
     */
    'companies'?: Array<CompanyIdV5x0>;
}
/**
 * 
 * @export
 * @interface PhoneHistoryItemV12
 */
export interface PhoneHistoryItemV12 {
    /**
     * 
     * @type {PhoneV1x1}
     * @memberof PhoneHistoryItemV12
     */
    'phone': PhoneV1x1;
    /**
     * 
     * @type {boolean}
     * @memberof PhoneHistoryItemV12
     */
    'primary': boolean;
}
/**
 * 
 * @export
 * @interface PhoneHistoryRecordV12
 */
export interface PhoneHistoryRecordV12 {
    /**
     * Time of record creation. yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof PhoneHistoryRecordV12
     */
    'createdAt': string;
    /**
     * Full name of consultant (if \'createdByPid\' is PID UUID) otherwise null. Supplied by pid-core.
     * @type {string}
     * @memberof PhoneHistoryRecordV12
     */
    'createdBy'?: string;
    /**
     * Source consultant (either PID UUID or some general string)
     * @type {string}
     * @memberof PhoneHistoryRecordV12
     */
    'createdByPid': string;
    /**
     * Defines a source client of an event. Possible values: [\'CODE\' - (Description)] - WARNING: This list is not commitment! - Note, this list may not be complete, or values may get removed without any notification. [ \'UNKNOWN\' - (), \'NONBANK\' - (Not a BANK; Nebanka), \'BANK\' - (Partners bank company), \'BANK_EMPLOYEE\' - (Identification of PID being employee (consultant) of the BANK), \'BANK_TEST\' - (), \'GEPARD\' - (Gepard Finance), \'LOAN\' - (Loan applicant indication), \'MOB_APP\' - (Mobile application (CZE)), \'MOB_APP_PAR\' - (Mobile application (Partners), \'MOB_APP_SFS\' - (Mobile application (Simplea Financial Solutions), \'MOB_APP_SK\' - (Mobile application (SVK)), \'MOB_APP_WLB\' - (Mobile application (White Label Product)), \'OCP\' - (Shares trading; Obchod s cennymi papiry), \'ORFEUS\' - (Alternative to FIP in a PFS world), \'ORFEUS_SK\' - (Alternative to FIP in a SFS world), \'PFS\' - (Partners Financial Services (CZE)), \'PFS_CONSULTANT\' - (Identification of PID being employee (consultant) of the PFS), \'PID\' - (), \'PID_TEST\' - (), \'RENTEA\' - (a retirement company (CZE)), \'SFS\' - (Simplea Financial Services (SVK)), \'SIMPLEA\' - (an insurance company (CZE)), \'SIMPLEA_SK\' - (an insurance company (SVK)), \'VUB\' - (VUB Bank) ]
     * @type {string}
     * @memberof PhoneHistoryRecordV12
     */
    'sourceClient': string;
    /**
     * 
     * @type {TrustLevelV11x0}
     * @memberof PhoneHistoryRecordV12
     */
    'trustLevel': TrustLevelV11x0;
    /**
     * Type of verification - the source of operation like OCR + validation scan or manual consultant input. Possible values: [\'CODE\' - (Description)] - WARNING: This list is not commitment! - Note, this list may not be complete, or values may get removed without any notification. [ \'UNKNOWN\' - (), \'MACHINE\' - (), \'AML_OFFICER\' - (), \'BACKOFFICE_USER\' - (), \'BANK_ID\' - (), \'CLIENT\' - (), \'CONSULTANT_EDOKLAD\' - (), \'CONSULTANT_FACE_TO_FACE\' - (), \'CONSULTANT_REMOTE\' - (), \'SZR\' - (Abbreviation for Czech Basic Public Administration Registers - \'Sprava Zakladnich Registru\'), ]
     * @type {string}
     * @memberof PhoneHistoryRecordV12
     */
    'verificationType': string;
    /**
     * Full name of person or company identified by \'createdByPid\'. Resolved by pid-backoffice-gateway.
     * @type {string}
     * @memberof PhoneHistoryRecordV12
     */
    'fullName'?: string;
    /**
     * 
     * @type {PhoneHistoryItemV12}
     * @memberof PhoneHistoryRecordV12
     */
    'record': PhoneHistoryItemV12;
}


/**
 * 
 * @export
 * @interface PhoneHistoryRecordV12AllOf
 */
export interface PhoneHistoryRecordV12AllOf {
    /**
     * 
     * @type {PhoneHistoryItemV12}
     * @memberof PhoneHistoryRecordV12AllOf
     */
    'record': PhoneHistoryItemV12;
}
/**
 * 
 * @export
 * @interface PhoneHistoryResponseV12
 */
export interface PhoneHistoryResponseV12 {
    /**
     * 
     * @type {Array<PhoneHistoryRecordV12>}
     * @memberof PhoneHistoryResponseV12
     */
    'records': Array<PhoneHistoryRecordV12>;
}
/**
 * A class represents phone number
 * @export
 * @interface PhoneV1x1
 */
export interface PhoneV1x1 {
    /**
     * End-User\'s preferred telephone number
     * @type {string}
     * @memberof PhoneV1x1
     */
    'phone': string;
    /**
     * End-User\'s preferred telephone number prefix
     * @type {string}
     * @memberof PhoneV1x1
     */
    'prefix': string;
}
/**
 * 
 * @export
 * @interface PidActionsV12
 */
export interface PidActionsV12 {
    /**
     * 
     * @type {boolean}
     * @memberof PidActionsV12
     */
    'updateEmail'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PidActionsV12
     */
    'updatePhone'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PidActionsV12
     */
    'updateClientName'?: boolean;
    /**
     * 
     * @type {CheckNationalIdentifierWrapperV12}
     * @memberof PidActionsV12
     */
    'updateNationalIdentifier'?: CheckNationalIdentifierWrapperV12;
    /**
     * 
     * @type {AddressActionsV12}
     * @memberof PidActionsV12
     */
    'updateAddress'?: AddressActionsV12;
    /**
     * 
     * @type {boolean}
     * @memberof PidActionsV12
     */
    'updateConsents'?: boolean;
    /**
     * 
     * @type {AisVerificationV12}
     * @memberof PidActionsV12
     */
    'aisVerification'?: AisVerificationV12;
    /**
     * 
     * @type {CheckIdCardActionsV12}
     * @memberof PidActionsV12
     */
    'idCard'?: CheckIdCardActionsV12;
    /**
     * 
     * @type {PidBlockageV12}
     * @memberof PidActionsV12
     */
    'pidBlockage'?: PidBlockageV12;
}
/**
 * 
 * @export
 * @interface PidBackOfficeSimpleSearchResultV12
 */
export interface PidBackOfficeSimpleSearchResultV12 {
    /**
     * 
     * @type {string}
     * @memberof PidBackOfficeSimpleSearchResultV12
     */
    'pidUuid': string;
    /**
     * 
     * @type {ClientInfoV12}
     * @memberof PidBackOfficeSimpleSearchResultV12
     */
    'clientInfo'?: ClientInfoV12;
    /**
     * 
     * @type {PhoneV1x1}
     * @memberof PidBackOfficeSimpleSearchResultV12
     */
    'phone'?: PhoneV1x1;
    /**
     * 
     * @type {EmailV11x0}
     * @memberof PidBackOfficeSimpleSearchResultV12
     */
    'email'?: EmailV11x0;
    /**
     * 
     * @type {string}
     * @memberof PidBackOfficeSimpleSearchResultV12
     */
    'createdDate': string;
    /**
     * 
     * @type {VerificationIdCardForSearchV12}
     * @memberof PidBackOfficeSimpleSearchResultV12
     */
    'idCard'?: VerificationIdCardForSearchV12;
    /**
     * 
     * @type {Array<NationalNumberV11x0>}
     * @memberof PidBackOfficeSimpleSearchResultV12
     */
    'nationalNumbers'?: Array<NationalNumberV11x0>;
    /**
     * 
     * @type {AddressV12}
     * @memberof PidBackOfficeSimpleSearchResultV12
     */
    'address'?: AddressV12;
    /**
     * 
     * @type {Array<RoleV11x0>}
     * @memberof PidBackOfficeSimpleSearchResultV12
     */
    'roles': Array<RoleV11x0>;
    /**
     * 
     * @type {PidFlagsNullableV12}
     * @memberof PidBackOfficeSimpleSearchResultV12
     */
    'flags': PidFlagsNullableV12;
}
/**
 * 
 * @export
 * @interface PidBasicDetailV12
 */
export interface PidBasicDetailV12 {
    /**
     * 
     * @type {BasicPidV12}
     * @memberof PidBasicDetailV12
     */
    'pid': BasicPidV12;
}
/**
 * 
 * @export
 * @interface PidBlockageV12
 */
export interface PidBlockageV12 {
    /**
     * 
     * @type {boolean}
     * @memberof PidBlockageV12
     */
    'blockPid': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PidBlockageV12
     */
    'unblockPid': boolean;
}
/**
 * 
 * @export
 * @interface PidDetailV12
 */
export interface PidDetailV12 {
    /**
     * 
     * @type {PidV12}
     * @memberof PidDetailV12
     */
    'pid': PidV12;
    /**
     * 
     * @type {Array<RoleV11x0>}
     * @memberof PidDetailV12
     */
    'clientRoles'?: Array<RoleV11x0> | null;
    /**
     * 
     * @type {PidFlagsV5x0}
     * @memberof PidDetailV12
     */
    'flags'?: PidFlagsV5x0;
    /**
     * 
     * @type {PidActionsV12}
     * @memberof PidDetailV12
     */
    'actions'?: PidActionsV12;
}
/**
 * 
 * @export
 * @interface PidFlagsNullableV12
 */
export interface PidFlagsNullableV12 {
    /**
     * 
     * @type {PidSearchEmployeeFlagV5x0}
     * @memberof PidFlagsNullableV12
     */
    'employee'?: PidSearchEmployeeFlagV5x0;
    /**
     * 
     * @type {TestClientFlagV5x0}
     * @memberof PidFlagsNullableV12
     */
    'testClient'?: TestClientFlagV5x0;
}
/**
 * 
 * @export
 * @interface PidFlagsV5x0
 */
export interface PidFlagsV5x0 {
    /**
     * 
     * @type {EmployeeFlagV5x0}
     * @memberof PidFlagsV5x0
     */
    'employee': EmployeeFlagV5x0;
    /**
     * 
     * @type {VerifiedInBRMV5x0}
     * @memberof PidFlagsV5x0
     */
    'verifiedInBRM': VerifiedInBRMV5x0;
    /**
     * 
     * @type {BankIdentityInNiaV5x0}
     * @memberof PidFlagsV5x0
     */
    'bankIdentityInNia'?: BankIdentityInNiaV5x0;
    /**
     * 
     * @type {boolean}
     * @memberof PidFlagsV5x0
     */
    'validClientshipsForAnalysisCreationInPfs': boolean;
}
/**
 * 
 * @export
 * @interface PidIdV1x1
 */
export interface PidIdV1x1 {
    /**
     * Unique identifier of the client
     * @type {string}
     * @memberof PidIdV1x1
     */
    'pidUuid': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PidReasonEnumV12 = {
    CLIENT_SERVIS: 'CLIENT_SERVIS',
    COOPERATION_WITH_AUTHORITIES: 'COOPERATION_WITH_AUTHORITIES',
    AML_OR_FRAUD: 'AML_OR_FRAUD',
    INTERNAL_CONTROL_OR_AUDIT: 'INTERNAL_CONTROL_OR_AUDIT',
    ISSUE_OR_INCIDENT: 'ISSUE_OR_INCIDENT',
    OTHER: 'OTHER'
} as const;

export type PidReasonEnumV12 = typeof PidReasonEnumV12[keyof typeof PidReasonEnumV12];


/**
 * A relationship between two PIDs
 * @export
 * @interface PidRelationshipV11x0
 */
export interface PidRelationshipV11x0 {
    /**
     * 
     * @type {PidIdV1x1}
     * @memberof PidRelationshipV11x0
     */
    'relatedPidId': PidIdV1x1;
    /**
     * 
     * @type {RelationshipTypeV11x0}
     * @memberof PidRelationshipV11x0
     */
    'type': RelationshipTypeV11x0;
    /**
     * Sample ID (ID of document from ZenId) used when the relationship is proved by a document.
     * @type {string}
     * @memberof PidRelationshipV11x0
     */
    'sampleId'?: string | null;
    /**
     * Investigation ID from ZenId used when the relationship is proved by a document.
     * @type {string}
     * @memberof PidRelationshipV11x0
     */
    'investigationId'?: string | null;
}


/**
 * 
 * @export
 * @interface PidSearchEmployeeFlagV5x0
 */
export interface PidSearchEmployeeFlagV5x0 {
    /**
     * 
     * @type {boolean}
     * @memberof PidSearchEmployeeFlagV5x0
     */
    'active': boolean;
    /**
     * 
     * @type {PartnersEmployeeTypeV5x0}
     * @memberof PidSearchEmployeeFlagV5x0
     */
    'type'?: PartnersEmployeeTypeV5x0;
    /**
     * 
     * @type {string}
     * @memberof PidSearchEmployeeFlagV5x0
     */
    'from'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const PidStatusV12 = {
    UNKNOWN: 'UNKNOWN',
    ACTIVE: 'ACTIVE',
    NON_ACTIVE: 'NON_ACTIVE',
    BLOCKED: 'BLOCKED',
    ANONYMIZED: 'ANONYMIZED',
    NON_IDENTIFIED: 'NON_IDENTIFIED'
} as const;

export type PidStatusV12 = typeof PidStatusV12[keyof typeof PidStatusV12];


/**
 * 
 * @export
 * @interface PidUuidRequestV12
 */
export interface PidUuidRequestV12 {
    /**
     * 
     * @type {PidReasonEnumV12}
     * @memberof PidUuidRequestV12
     */
    'reason'?: PidReasonEnumV12;
    /**
     * Detailed description of reason in case reason is OTHER
     * @type {string}
     * @memberof PidUuidRequestV12
     */
    'additionalReason'?: string | null;
}


/**
 * 
 * @export
 * @interface PidV12
 */
export interface PidV12 {
    /**
     * Unique identifier of the client
     * @type {string}
     * @memberof PidV12
     */
    'pidUuid': string;
    /**
     * 
     * @type {string}
     * @memberof PidV12
     */
    'bsi'?: string;
    /**
     * 
     * @type {PidStatusV12}
     * @memberof PidV12
     */
    'pidStatus'?: PidStatusV12;
    /**
     * 
     * @type {Array<VerificationNationalNumberV12>}
     * @memberof PidV12
     */
    'verificationNationalNumbers'?: Array<VerificationNationalNumberV12>;
    /**
     * 
     * @type {Array<VerificationPhoneV12>}
     * @memberof PidV12
     */
    'verificationPhones'?: Array<VerificationPhoneV12>;
    /**
     * 
     * @type {Array<VerificationEmailV12>}
     * @memberof PidV12
     */
    'verificationEmails'?: Array<VerificationEmailV12>;
    /**
     * 
     * @type {VerificationClientInfoV12}
     * @memberof PidV12
     */
    'verificationClientInfo'?: VerificationClientInfoV12;
    /**
     * 
     * @type {VerificationAdditionalClientInfoV12}
     * @memberof PidV12
     */
    'verificationAdditionalClientInfo'?: VerificationAdditionalClientInfoV12;
    /**
     * 
     * @type {Array<VerificationAddressV12>}
     * @memberof PidV12
     */
    'verificationAddresses'?: Array<VerificationAddressV12>;
    /**
     * 
     * @type {Array<VerificationIdCardV12>}
     * @memberof PidV12
     */
    'verificationIdCards'?: Array<VerificationIdCardV12>;
    /**
     * 
     * @type {Array<VerificationBankAccountV12>}
     * @memberof PidV12
     */
    'verificationBankAccount'?: Array<VerificationBankAccountV12>;
    /**
     * 
     * @type {Array<VerificationConsentAgreementV12>}
     * @memberof PidV12
     */
    'verificationConsentAgreements'?: Array<VerificationConsentAgreementV12>;
    /**
     * 
     * @type {Array<VerificationPidRelationshipV12>}
     * @memberof PidV12
     */
    'verificationPidRelationships'?: Array<VerificationPidRelationshipV12>;
    /**
     * 
     * @type {VerificationAmlV12}
     * @memberof PidV12
     */
    'verificationAml'?: VerificationAmlV12;
    /**
     * National context define source of client. ISO 3166-1 format, subtype ALPHA-3. This means three letters in uppercase. Possible values: [\'CODE\' - (Description)] - WARNING: This list is not commitment! - Note, this list may not be complete, or values may get removed without any notification. [ \'CZE\' - (), \'SVK\' - (), ]
     * @type {string}
     * @memberof PidV12
     */
    'nationalContext': string;
    /**
     * 
     * @type {Array<VerificationClientshipV12>}
     * @memberof PidV12
     */
    'verificationClientships'?: Array<VerificationClientshipV12>;
    /**
     * 
     * @type {Array<VerificationInvestigationV12>}
     * @memberof PidV12
     */
    'verificationInvestigations'?: Array<VerificationInvestigationV12>;
    /**
     * 
     * @type {Array<VerificationDataboxV12>}
     * @memberof PidV12
     */
    'verificationDataboxes'?: Array<VerificationDataboxV12>;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ProcessTypeV12 = {
    BANK_ID_ACTIVATION: 'BANK_ID_ACTIVATION',
    BANK_ID_ONBOARDING: 'BANK_ID_ONBOARDING',
    CHILD_ONBOARDING: 'CHILD_ONBOARDING',
    CONSULTANT_QR_ACTIVATION: 'CONSULTANT_QR_ACTIVATION',
    DEVICE_QR_ACTIVATION: 'DEVICE_QR_ACTIVATION',
    ID_SCAN_ACTIVATION: 'ID_SCAN_ACTIVATION'
} as const;

export type ProcessTypeV12 = typeof ProcessTypeV12[keyof typeof ProcessTypeV12];


/**
 * Code of regular income.
 * @export
 * @enum {string}
 */

export const RegularIncomeEsaCodeV5x0 = {
    UNKNOWN: 'UNKNOWN',
    OCCUPATION: 'OCCUPATION',
    PART_TIME: 'PART_TIME',
    SELF_EMPLOYMENT: 'SELF_EMPLOYMENT',
    BUSINESS_ACTIVITIES: 'BUSINESS_ACTIVITIES',
    PARENTAL_LEAVE: 'PARENTAL_LEAVE',
    SOCIAL_BENEFITS: 'SOCIAL_BENEFITS',
    PENSION: 'PENSION',
    ALIMONY: 'ALIMONY',
    CAPITAL_PROPERTY: 'CAPITAL_PROPERTY',
    RENT: 'RENT',
    RECURRING_BONUSES: 'RECURRING_BONUSES',
    AGREEMENT: 'AGREEMENT',
    DIVIDENDS: 'DIVIDENDS',
    PARTNER_PROFIT: 'PARTNER_PROFIT'
} as const;

export type RegularIncomeEsaCodeV5x0 = typeof RegularIncomeEsaCodeV5x0[keyof typeof RegularIncomeEsaCodeV5x0];


/**
 * Relationship type between two PIDs
 * @export
 * @enum {string}
 */

export const RelationshipTypeV11x0 = {
    UNKNOWN: 'UNKNOWN',
    CHILD_TO_PARENT: 'CHILD_TO_PARENT',
    PARENT_TO_CHILD: 'PARENT_TO_CHILD',
    GUARDIAN_OF: 'GUARDIAN_OF',
    GUARDED_BY: 'GUARDED_BY',
    EMPLOYEE_GUARDIAN_OF: 'EMPLOYEE_GUARDIAN_OF',
    GUARDED_BY_EMPLOYEE: 'GUARDED_BY_EMPLOYEE',
    LOA_EMPOWERING_WHO: 'LOA_EMPOWERING_WHO',
    LOA_EMPOWERED_BY: 'LOA_EMPOWERED_BY',
    LEGAL_REPRESENTATIVE_OF: 'LEGAL_REPRESENTATIVE_OF',
    LEGAL_REPRESENTED_BY: 'LEGAL_REPRESENTED_BY'
} as const;

export type RelationshipTypeV11x0 = typeof RelationshipTypeV11x0[keyof typeof RelationshipTypeV11x0];


/**
 * 
 * @export
 * @enum {string}
 */

export const RoleV11x0 = {
    ONBOARD_USER: 'ROLE_ONBOARD_USER',
    PID_USER: 'ROLE_PID_USER',
    PFS_USER: 'ROLE_PFS_USER',
    BANK_USER: 'ROLE_BANK_USER',
    BANK_CHILD_USER: 'ROLE_BANK_CHILD_USER',
    PID_BACKOFFICE_USER: 'ROLE_PID_BACKOFFICE_USER',
    BANK_BACKOFFICE_USER: 'ROLE_BANK_BACKOFFICE_USER'
} as const;

export type RoleV11x0 = typeof RoleV11x0[keyof typeof RoleV11x0];


/**
 * 
 * @export
 * @interface SearchClientsRequestV12
 */
export interface SearchClientsRequestV12 {
    /**
     * 
     * @type {string}
     * @memberof SearchClientsRequestV12
     */
    'pidUuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchClientsRequestV12
     */
    'givenName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchClientsRequestV12
     */
    'familyName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchClientsRequestV12
     */
    'birthday'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchClientsRequestV12
     */
    'nationalNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchClientsRequestV12
     */
    'idCardNumber'?: string | null;
    /**
     * 
     * @type {EmailV11x0}
     * @memberof SearchClientsRequestV12
     */
    'email'?: EmailV11x0;
    /**
     * 
     * @type {PhoneV1x1}
     * @memberof SearchClientsRequestV12
     */
    'phone'?: PhoneV1x1;
    /**
     * 
     * @type {string}
     * @memberof SearchClientsRequestV12
     */
    'createdDateFrom'?: string | null;
    /**
     * 
     * @type {PageableV1x0}
     * @memberof SearchClientsRequestV12
     */
    'pageable': PageableV1x0;
    /**
     * 
     * @type {ClientSearchSortV12}
     * @memberof SearchClientsRequestV12
     */
    'sort'?: ClientSearchSortV12;
}
/**
 * 
 * @export
 * @interface SearchClientsResponseV12
 */
export interface SearchClientsResponseV12 {
    /**
     * 
     * @type {Array<ClientV12>}
     * @memberof SearchClientsResponseV12
     */
    'results': Array<ClientV12>;
    /**
     * 
     * @type {PageableResponseV1x0}
     * @memberof SearchClientsResponseV12
     */
    'pageable': PageableResponseV1x0;
}
/**
 * 
 * @export
 * @interface SimpleSearchClientsRequestV12
 */
export interface SimpleSearchClientsRequestV12 {
    /**
     * 
     * @type {string}
     * @memberof SimpleSearchClientsRequestV12
     */
    'search': string;
    /**
     * 
     * @type {PageableV1x0}
     * @memberof SimpleSearchClientsRequestV12
     */
    'pageable': PageableV1x0;
    /**
     * 
     * @type {ClientSearchSortV12}
     * @memberof SimpleSearchClientsRequestV12
     */
    'sort'?: ClientSearchSortV12;
}
/**
 * 
 * @export
 * @interface SimpleSearchClientsResponseV12
 */
export interface SimpleSearchClientsResponseV12 {
    /**
     * 
     * @type {Array<PidBackOfficeSimpleSearchResultV12>}
     * @memberof SimpleSearchClientsResponseV12
     */
    'pidBackOfficeSearchResults': Array<PidBackOfficeSimpleSearchResultV12>;
    /**
     * 
     * @type {PageableResponseV1x0}
     * @memberof SimpleSearchClientsResponseV12
     */
    'pageable': PageableResponseV1x0;
}
/**
 * Sorting order - ascendent or descendent.
 * @export
 * @enum {string}
 */

export const SortOrderTypeV1x0 = {
    ASC: 'ASC',
    DESC: 'DESC'
} as const;

export type SortOrderTypeV1x0 = typeof SortOrderTypeV1x0[keyof typeof SortOrderTypeV1x0];


/**
 * Defines a source client of an event.
 * @export
 * @enum {string}
 */

export const SourceClientEnumV5x0 = {
    UNKNOWN: 'UNKNOWN',
    NONBANK: 'NONBANK',
    BANK: 'BANK',
    BANK_EMPLOYEE: 'BANK_EMPLOYEE',
    BANK_TEST: 'BANK_TEST',
    GEPARD: 'GEPARD',
    LOAN: 'LOAN',
    MOB_APP: 'MOB_APP',
    MOB_APP_SK: 'MOB_APP_SK',
    OCP: 'OCP',
    ORFEUS: 'ORFEUS',
    ORFEUS_SK: 'ORFEUS_SK',
    PFS: 'PFS',
    PFS_CONSULTANT: 'PFS_CONSULTANT',
    PID: 'PID',
    PID_TEST: 'PID_TEST',
    RENTEA: 'RENTEA',
    SFS: 'SFS',
    SIMPLEA: 'SIMPLEA',
    SIMPLEA_SK: 'SIMPLEA_SK',
    VUB: 'VUB',
    MOB_APP_PAR: 'MOB_APP_PAR',
    MOB_APP_SFS: 'MOB_APP_SFS',
    MOB_APP_WLB: 'MOB_APP_WLB'
} as const;

export type SourceClientEnumV5x0 = typeof SourceClientEnumV5x0[keyof typeof SourceClientEnumV5x0];


/**
 * 
 * @export
 * @interface TestClientFlagV5x0
 */
export interface TestClientFlagV5x0 {
    /**
     * 
     * @type {boolean}
     * @memberof TestClientFlagV5x0
     */
    'active': boolean;
    /**
     * 
     * @type {string}
     * @memberof TestClientFlagV5x0
     */
    'from'?: string | null;
}
/**
 * Trust level defines truthfulness of the field.
 * @export
 * @enum {string}
 */

export const TrustLevelV11x0 = {
    UNKNOWN: 'UNKNOWN',
    UNVERIFIED: 'UNVERIFIED',
    VERIFIED: 'VERIFIED',
    PID_VERIFIED: 'PID_VERIFIED',
    BLOCKED: 'BLOCKED'
} as const;

export type TrustLevelV11x0 = typeof TrustLevelV11x0[keyof typeof TrustLevelV11x0];


/**
 * 
 * @export
 * @interface VerificationAdditionalClientInfoV12
 */
export interface VerificationAdditionalClientInfoV12 {
    /**
     * 
     * @type {AdditionalClientInfoV12}
     * @memberof VerificationAdditionalClientInfoV12
     */
    'additionalClientInfo': AdditionalClientInfoV12;
    /**
     * 
     * @type {VerificationTypeEnumV12}
     * @memberof VerificationAdditionalClientInfoV12
     */
    'verificationType'?: VerificationTypeEnumV12;
    /**
     * 
     * @type {TrustLevelV11x0}
     * @memberof VerificationAdditionalClientInfoV12
     */
    'trustLevel': TrustLevelV11x0;
    /**
     * 
     * @type {SourceClientEnumV5x0}
     * @memberof VerificationAdditionalClientInfoV12
     */
    'sourceClient'?: SourceClientEnumV5x0;
    /**
     * External DB ID of consultant, will be replaced by PID_ID in the future (SSO).
     * @type {string}
     * @memberof VerificationAdditionalClientInfoV12
     */
    'sourceConsultant': string;
    /**
     * Time of record creation. yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof VerificationAdditionalClientInfoV12
     */
    'createdAt'?: string;
    /**
     * Time of record last update. yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof VerificationAdditionalClientInfoV12
     */
    'updatedAt'?: string;
}


/**
 * 
 * @export
 * @interface VerificationAddressV12
 */
export interface VerificationAddressV12 {
    /**
     * 
     * @type {AddressV12}
     * @memberof VerificationAddressV12
     */
    'address': AddressV12;
    /**
     * 
     * @type {AddressTypeV11x0}
     * @memberof VerificationAddressV12
     */
    'type': AddressTypeV11x0;
    /**
     * 
     * @type {VerificationTypeEnumV12}
     * @memberof VerificationAddressV12
     */
    'verificationType'?: VerificationTypeEnumV12;
    /**
     * 
     * @type {TrustLevelV11x0}
     * @memberof VerificationAddressV12
     */
    'trustLevel': TrustLevelV11x0;
    /**
     * 
     * @type {SourceClientEnumV5x0}
     * @memberof VerificationAddressV12
     */
    'sourceClient'?: SourceClientEnumV5x0;
    /**
     * External DB ID of consultant, will be replaced by PID_ID in the future (SSO).
     * @type {string}
     * @memberof VerificationAddressV12
     */
    'sourceConsultant': string;
    /**
     * Time of record creation. yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof VerificationAddressV12
     */
    'createdAt'?: string;
    /**
     * Time of record last update. yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof VerificationAddressV12
     */
    'updatedAt'?: string;
}


/**
 * Verification wrapper of Aml.
 * @export
 * @interface VerificationAmlV12
 */
export interface VerificationAmlV12 {
    /**
     * 
     * @type {AmlV12}
     * @memberof VerificationAmlV12
     */
    'aml': AmlV12;
    /**
     * 
     * @type {VerificationTypeEnumV12}
     * @memberof VerificationAmlV12
     */
    'verificationType'?: VerificationTypeEnumV12;
    /**
     * 
     * @type {TrustLevelV11x0}
     * @memberof VerificationAmlV12
     */
    'trustLevel': TrustLevelV11x0;
    /**
     * 
     * @type {SourceClientEnumV5x0}
     * @memberof VerificationAmlV12
     */
    'sourceClient'?: SourceClientEnumV5x0;
    /**
     * External DB ID of consultant, will be replaced by PID_ID in the future (SSO).
     * @type {string}
     * @memberof VerificationAmlV12
     */
    'sourceConsultant': string;
    /**
     * Time of record creation. yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof VerificationAmlV12
     */
    'createdAt'?: string;
    /**
     * Time of record last update. yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof VerificationAmlV12
     */
    'updatedAt'?: string;
}


/**
 * Verification bank account
 * @export
 * @interface VerificationBankAccountV12
 */
export interface VerificationBankAccountV12 {
    /**
     * 
     * @type {BankAccountV12}
     * @memberof VerificationBankAccountV12
     */
    'bankAccount': BankAccountV12;
    /**
     * 
     * @type {VerificationTypeEnumV12}
     * @memberof VerificationBankAccountV12
     */
    'verificationType'?: VerificationTypeEnumV12;
    /**
     * 
     * @type {TrustLevelV11x0}
     * @memberof VerificationBankAccountV12
     */
    'trustLevel': TrustLevelV11x0;
    /**
     * 
     * @type {SourceClientEnumV5x0}
     * @memberof VerificationBankAccountV12
     */
    'sourceClient'?: SourceClientEnumV5x0;
    /**
     * External DB ID of consultant, will be replaced by PID_ID in the future (SSO).
     * @type {string}
     * @memberof VerificationBankAccountV12
     */
    'sourceConsultant': string;
    /**
     * Time of record creation. yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof VerificationBankAccountV12
     */
    'createdAt'?: string;
    /**
     * Time of record last update. yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof VerificationBankAccountV12
     */
    'updatedAt'?: string;
}


/**
 * 
 * @export
 * @interface VerificationClientInfoV12
 */
export interface VerificationClientInfoV12 {
    /**
     * 
     * @type {ClientInfoV12}
     * @memberof VerificationClientInfoV12
     */
    'clientInfo': ClientInfoV12;
    /**
     * 
     * @type {VerificationTypeEnumV12}
     * @memberof VerificationClientInfoV12
     */
    'verificationType'?: VerificationTypeEnumV12;
    /**
     * 
     * @type {TrustLevelV11x0}
     * @memberof VerificationClientInfoV12
     */
    'trustLevel': TrustLevelV11x0;
    /**
     * 
     * @type {SourceClientEnumV5x0}
     * @memberof VerificationClientInfoV12
     */
    'sourceClient'?: SourceClientEnumV5x0;
    /**
     * External DB ID of consultant, will be replaced by PID_ID in the future (SSO).
     * @type {string}
     * @memberof VerificationClientInfoV12
     */
    'sourceConsultant': string;
    /**
     * Time of record creation. yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof VerificationClientInfoV12
     */
    'createdAt'?: string;
    /**
     * Time of record last update. yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof VerificationClientInfoV12
     */
    'updatedAt'?: string;
}


/**
 * Information about connection between a company and the PID
 * @export
 * @interface VerificationClientshipV12
 */
export interface VerificationClientshipV12 {
    /**
     * Identifier in National Registers of Czech republic given for a physical person distinctly per company. It is an abbreviation of \'Agendový identifikátor fyzické osoby\'
     * @type {string}
     * @memberof VerificationClientshipV12
     */
    'aifo'?: string;
    /**
     * 
     * @type {AisStatusEnumV12}
     * @memberof VerificationClientshipV12
     */
    'aisStatus': AisStatusEnumV12;
    /**
     * Time of last change of aifoStatus
     * @type {string}
     * @memberof VerificationClientshipV12
     */
    'aisStatusChangedAt': string;
    /**
     * Timestamp when anonymization flag has been set
     * @type {string}
     * @memberof VerificationClientshipV12
     */
    'anonymizationTimestamp'?: string;
    /**
     * Time of starting cooperation with the company
     * @type {string}
     * @memberof VerificationClientshipV12
     */
    'companyClientFrom': string;
    /**
     * 
     * @type {CompanyIdV5x0}
     * @memberof VerificationClientshipV12
     */
    'companyId': CompanyIdV5x0;
    /**
     * 
     * @type {string}
     * @memberof VerificationClientshipV12
     */
    'createdAt': string;
    /**
     * Time of retention (which is expected date of anonymization)
     * @type {string}
     * @memberof VerificationClientshipV12
     */
    'retentionDate'?: string;
    /**
     * Timestamp of executed client anonymization in a source system of a company
     * @type {string}
     * @memberof VerificationClientshipV12
     */
    'sourceAnonymizationTimestamp'?: string;
    /**
     * External DB ID of consultant, will be replaced by PID_ID in the future (SSO)
     * @type {string}
     * @memberof VerificationClientshipV12
     */
    'sourceConsultant': string;
    /**
     * 
     * @type {string}
     * @memberof VerificationClientshipV12
     */
    'updatedAt': string;
    /**
     * Time of validity start (assignment)
     * @type {string}
     * @memberof VerificationClientshipV12
     */
    'validFrom': string;
    /**
     * Time of validity end (termination)
     * @type {string}
     * @memberof VerificationClientshipV12
     */
    'validTo'?: string;
    /**
     * 
     * @type {VerificationTypeEnumV12}
     * @memberof VerificationClientshipV12
     */
    'verificationType': VerificationTypeEnumV12;
    /**
     * Indicates whether the client was identified during data collection
     * @type {boolean}
     * @memberof VerificationClientshipV12
     */
    'identified': boolean;
}


/**
 * 
 * @export
 * @interface VerificationConsentAgreementV12
 */
export interface VerificationConsentAgreementV12 {
    /**
     * 
     * @type {ConsentV11x0}
     * @memberof VerificationConsentAgreementV12
     */
    'consent': ConsentV11x0;
    /**
     * 
     * @type {boolean}
     * @memberof VerificationConsentAgreementV12
     */
    'agreed': boolean;
    /**
     * 
     * @type {VerificationTypeEnumV12}
     * @memberof VerificationConsentAgreementV12
     */
    'verificationType'?: VerificationTypeEnumV12;
    /**
     * 
     * @type {TrustLevelV11x0}
     * @memberof VerificationConsentAgreementV12
     */
    'trustLevel': TrustLevelV11x0;
    /**
     * 
     * @type {SourceClientEnumV5x0}
     * @memberof VerificationConsentAgreementV12
     */
    'sourceClient'?: SourceClientEnumV5x0;
    /**
     * External DB ID of consultant, will be replaced by PID_ID in the future (SSO).
     * @type {string}
     * @memberof VerificationConsentAgreementV12
     */
    'sourceConsultant': string;
    /**
     * Time of record creation. yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof VerificationConsentAgreementV12
     */
    'createdAt'?: string;
    /**
     * Time of record last update. yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof VerificationConsentAgreementV12
     */
    'updatedAt'?: string;
}


/**
 * Verification wrapper of PID Databox
 * @export
 * @interface VerificationDataboxV12
 */
export interface VerificationDataboxV12 {
    /**
     * Time of record creation. yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof VerificationDataboxV12
     */
    'createdAt': string;
    /**
     * Defines a source client of an event. Possible values: [\'CODE\' - (Description)] - WARNING: This list is not commitment! - Note, this list may not be complete, or values may get removed without any notification. [ \'UNKNOWN\' - (), \'NONBANK\' - (Not a BANK; Nebanka), \'BANK\' - (Partners bank company), \'BANK_EMPLOYEE\' - (Identification of PID being employee (consultant) of the BANK), \'BANK_TEST\' - (), \'GEPARD\' - (Gepard Finance), \'LOAN\' - (Loan applicant indication), \'MOB_APP\' - (Mobile application (CZE)), \'MOB_APP_PAR\' - (Mobile application (Partners), \'MOB_APP_SFS\' - (Mobile application (Simplea Financial Solutions), \'MOB_APP_SK\' - (Mobile application (SVK)), \'MOB_APP_WLB\' - (Mobile application (White Label Product)), \'OCP\' - (Shares trading; Obchod s cennymi papiry), \'ORFEUS\' - (Alternative to FIP in a PFS world), \'ORFEUS_SK\' - (Alternative to FIP in a SFS world), \'PFS\' - (Partners Financial Services (CZE)), \'PFS_CONSULTANT\' - (Identification of PID being employee (consultant) of the PFS), \'PID\' - (), \'PID_TEST\' - (), \'RENTEA\' - (a retirement company (CZE)), \'SFS\' - (Simplea Financial Services (SVK)), \'SIMPLEA\' - (an insurance company (CZE)), \'SIMPLEA_SK\' - (an insurance company (SVK)), \'VUB\' - (VUB Bank) ]
     * @type {string}
     * @memberof VerificationDataboxV12
     */
    'sourceClient': string;
    /**
     * External DB ID of consultant, will be replaced by PID_ID in the future (SSO).
     * @type {string}
     * @memberof VerificationDataboxV12
     */
    'sourceConsultant': string;
    /**
     * 
     * @type {TrustLevelV11x0}
     * @memberof VerificationDataboxV12
     */
    'trustLevel': TrustLevelV11x0;
    /**
     * Time of record last update. yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof VerificationDataboxV12
     */
    'updatedAt': string;
    /**
     * Time of the data verification (when the data were acquired in a source system) yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof VerificationDataboxV12
     */
    'verificationDate': string;
    /**
     * Type of verification - the source of operation like OCR + validation scan or manual consultant input. Possible values: [\'CODE\' - (Description)] - WARNING: This list is not commitment! - Note, this list may not be complete, or values may get removed without any notification. [ \'UNKNOWN\' - (), \'MACHINE\' - (), \'AML_OFFICER\' - (), \'BACKOFFICE_USER\' - (), \'BANK_ID\' - (), \'CLIENT\' - (), \'CONSULTANT_EDOKLAD\' - (), \'CONSULTANT_FACE_TO_FACE\' - (), \'CONSULTANT_REMOTE\' - (), \'SZR\' - (Abbreviation for Czech Basic Public Administration Registers - \'Sprava Zakladnich Registru\'), ]
     * @type {string}
     * @memberof VerificationDataboxV12
     */
    'verificationType': string;
    /**
     * 
     * @type {DataboxV11x0}
     * @memberof VerificationDataboxV12
     */
    'databox': DataboxV11x0;
}


/**
 * Verification wrapper of email.
 * @export
 * @interface VerificationEmailV12
 */
export interface VerificationEmailV12 {
    /**
     * 
     * @type {EmailV11x0}
     * @memberof VerificationEmailV12
     */
    'email': EmailV11x0;
    /**
     * Primary flag
     * @type {boolean}
     * @memberof VerificationEmailV12
     */
    'primary': boolean;
    /**
     * 
     * @type {VerificationTypeEnumV12}
     * @memberof VerificationEmailV12
     */
    'verificationType'?: VerificationTypeEnumV12;
    /**
     * 
     * @type {TrustLevelV11x0}
     * @memberof VerificationEmailV12
     */
    'trustLevel': TrustLevelV11x0;
    /**
     * 
     * @type {SourceClientEnumV5x0}
     * @memberof VerificationEmailV12
     */
    'sourceClient'?: SourceClientEnumV5x0;
    /**
     * External DB ID of consultant, will be replaced by PID_ID in the future (SSO).
     * @type {string}
     * @memberof VerificationEmailV12
     */
    'sourceConsultant': string;
    /**
     * Time of record creation. yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof VerificationEmailV12
     */
    'createdAt'?: string;
    /**
     * Time of record last update. yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof VerificationEmailV12
     */
    'updatedAt'?: string;
}


/**
 * 
 * @export
 * @interface VerificationIdCardForSearchV12
 */
export interface VerificationIdCardForSearchV12 {
    /**
     * 
     * @type {IdCardV12}
     * @memberof VerificationIdCardForSearchV12
     */
    'idCard': IdCardV12;
    /**
     * Type of verification - the source of operation like OCR + validation scan or manual consultant input. Possible values: [\'CODE\' - (Description)] - WARNING: This list is not commitment! - Note, this list may not be complete, or values may get removed without any notification. [ \'UNKNOWN\' - (), \'MACHINE\' - (), \'AML_OFFICER\' - (), \'BACKOFFICE_USER\' - (), \'BANK_ID\' - (), \'CLIENT\' - (), \'CONSULTANT_EDOKLAD\' - (), \'CONSULTANT_FACE_TO_FACE\' - (), \'CONSULTANT_REMOTE\' - (), \'SZR\' - (Abbreviation for Czech Basic Public Administration Registers - \'Sprava Zakladnich Registru\'), ]
     * @type {string}
     * @memberof VerificationIdCardForSearchV12
     */
    'verificationType'?: string;
    /**
     * 
     * @type {TrustLevelV11x0}
     * @memberof VerificationIdCardForSearchV12
     */
    'trustLevel': TrustLevelV11x0;
    /**
     * 
     * @type {SourceClientEnumV5x0}
     * @memberof VerificationIdCardForSearchV12
     */
    'sourceClient'?: SourceClientEnumV5x0;
    /**
     * External DB ID of consultant, will be replaced by PID_ID in the future (SSO).
     * @type {string}
     * @memberof VerificationIdCardForSearchV12
     */
    'sourceConsultant': string;
    /**
     * Time of record creation. yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof VerificationIdCardForSearchV12
     */
    'createdAt'?: string;
    /**
     * Time of record last update. yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof VerificationIdCardForSearchV12
     */
    'updatedAt'?: string;
}


/**
 * 
 * @export
 * @interface VerificationIdCardV12
 */
export interface VerificationIdCardV12 {
    /**
     * 
     * @type {IdCardV12}
     * @memberof VerificationIdCardV12
     */
    'idCard': IdCardV12;
    /**
     * 
     * @type {VerificationTypeEnumV12}
     * @memberof VerificationIdCardV12
     */
    'verificationType'?: VerificationTypeEnumV12;
    /**
     * 
     * @type {TrustLevelV11x0}
     * @memberof VerificationIdCardV12
     */
    'trustLevel': TrustLevelV11x0;
    /**
     * 
     * @type {SourceClientEnumV5x0}
     * @memberof VerificationIdCardV12
     */
    'sourceClient'?: SourceClientEnumV5x0;
    /**
     * External DB ID of consultant, will be replaced by PID_ID in the future (SSO).
     * @type {string}
     * @memberof VerificationIdCardV12
     */
    'sourceConsultant': string;
    /**
     * Time of record creation. yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof VerificationIdCardV12
     */
    'createdAt'?: string;
    /**
     * Time of record last update. yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof VerificationIdCardV12
     */
    'updatedAt'?: string;
}


/**
 * Verification wrapper of ZenId investigation
 * @export
 * @interface VerificationInvestigationV12
 */
export interface VerificationInvestigationV12 {
    /**
     * Time of record creation. yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof VerificationInvestigationV12
     */
    'createdAt': string;
    /**
     * 
     * @type {SourceClientEnumV5x0}
     * @memberof VerificationInvestigationV12
     */
    'sourceClient': SourceClientEnumV5x0;
    /**
     * External DB ID of consultant, will be replaced by PID_ID in the future (SSO).
     * @type {string}
     * @memberof VerificationInvestigationV12
     */
    'sourceConsultant': string;
    /**
     * 
     * @type {TrustLevelV11x0}
     * @memberof VerificationInvestigationV12
     */
    'trustLevel': TrustLevelV11x0;
    /**
     * Time of record last update. yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof VerificationInvestigationV12
     */
    'updatedAt': string;
    /**
     * Time of the data verification (when the data were acquired in a source system) yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof VerificationInvestigationV12
     */
    'verificationDate': string;
    /**
     * 
     * @type {VerificationTypeEnumV12}
     * @memberof VerificationInvestigationV12
     */
    'verificationType': VerificationTypeEnumV12;
    /**
     * 
     * @type {string}
     * @memberof VerificationInvestigationV12
     */
    'investigationId': string;
    /**
     * 
     * @type {string}
     * @memberof VerificationInvestigationV12
     */
    'idCardNumber': string;
}


/**
 * Verification wrap of national number.
 * @export
 * @interface VerificationNationalNumberV12
 */
export interface VerificationNationalNumberV12 {
    /**
     * 
     * @type {NationalNumberV11x0}
     * @memberof VerificationNationalNumberV12
     */
    'nationalNumber': NationalNumberV11x0;
    /**
     * 
     * @type {VerificationTypeEnumV12}
     * @memberof VerificationNationalNumberV12
     */
    'verificationType'?: VerificationTypeEnumV12;
    /**
     * 
     * @type {TrustLevelV11x0}
     * @memberof VerificationNationalNumberV12
     */
    'trustLevel': TrustLevelV11x0;
    /**
     * 
     * @type {SourceClientEnumV5x0}
     * @memberof VerificationNationalNumberV12
     */
    'sourceClient'?: SourceClientEnumV5x0;
    /**
     * External DB ID of consultant, will be replaced by PID_ID in the future (SSO).
     * @type {string}
     * @memberof VerificationNationalNumberV12
     */
    'sourceConsultant': string;
    /**
     * Time of record creation. yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof VerificationNationalNumberV12
     */
    'createdAt'?: string;
    /**
     * Time of record last update. yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof VerificationNationalNumberV12
     */
    'updatedAt'?: string;
    /**
     * Time of the data verification (when the data were acquired in a source system) yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof VerificationNationalNumberV12
     */
    'verificationDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VerificationNationalNumberV12
     */
    'isBlacklisted'?: boolean;
}


/**
 * Verification wrapper of Phone.
 * @export
 * @interface VerificationPhoneV12
 */
export interface VerificationPhoneV12 {
    /**
     * 
     * @type {PhoneV1x1}
     * @memberof VerificationPhoneV12
     */
    'phone': PhoneV1x1;
    /**
     * Primary flag
     * @type {boolean}
     * @memberof VerificationPhoneV12
     */
    'primary': boolean;
    /**
     * 
     * @type {VerificationTypeEnumV12}
     * @memberof VerificationPhoneV12
     */
    'verificationType'?: VerificationTypeEnumV12;
    /**
     * 
     * @type {TrustLevelV11x0}
     * @memberof VerificationPhoneV12
     */
    'trustLevel': TrustLevelV11x0;
    /**
     * 
     * @type {SourceClientEnumV5x0}
     * @memberof VerificationPhoneV12
     */
    'sourceClient'?: SourceClientEnumV5x0;
    /**
     * External DB ID of consultant, will be replaced by PID_ID in the future (SSO).
     * @type {string}
     * @memberof VerificationPhoneV12
     */
    'sourceConsultant': string;
    /**
     * Time of record creation. yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof VerificationPhoneV12
     */
    'createdAt'?: string;
    /**
     * Time of record last update. yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof VerificationPhoneV12
     */
    'updatedAt'?: string;
}


/**
 * Verification wrapper of PID Relationship.
 * @export
 * @interface VerificationPidRelationshipV12
 */
export interface VerificationPidRelationshipV12 {
    /**
     * 
     * @type {PidRelationshipV11x0}
     * @memberof VerificationPidRelationshipV12
     */
    'pidRelationship': PidRelationshipV11x0;
    /**
     * 
     * @type {VerificationTypeEnumV12}
     * @memberof VerificationPidRelationshipV12
     */
    'verificationType'?: VerificationTypeEnumV12;
    /**
     * 
     * @type {TrustLevelV11x0}
     * @memberof VerificationPidRelationshipV12
     */
    'trustLevel': TrustLevelV11x0;
    /**
     * 
     * @type {SourceClientEnumV5x0}
     * @memberof VerificationPidRelationshipV12
     */
    'sourceClient'?: SourceClientEnumV5x0;
    /**
     * External DB ID of consultant, will be replaced by PID_ID in the future (SSO).
     * @type {string}
     * @memberof VerificationPidRelationshipV12
     */
    'sourceConsultant': string;
    /**
     * Time of record creation. yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof VerificationPidRelationshipV12
     */
    'createdAt'?: string;
    /**
     * Time of record last update. yyyy-MM-dd\'T\'HH:mm:ss.SSSZ
     * @type {string}
     * @memberof VerificationPidRelationshipV12
     */
    'updatedAt'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const VerificationTypeEnumV12 = {
    MACHINE: 'MACHINE',
    AML_OFFICER: 'AML_OFFICER',
    BACKOFFICE_USER: 'BACKOFFICE_USER',
    BANK_ID: 'BANK_ID',
    CLIENT: 'CLIENT',
    CONSULTANT_EDOKLAD: 'CONSULTANT_EDOKLAD',
    CONSULTANT_FACE_TO_FACE: 'CONSULTANT_FACE_TO_FACE',
    CONSULTANT_REMOTE: 'CONSULTANT_REMOTE',
    SZR: 'SZR',
    UNKNOWN: 'UNKNOWN'
} as const;

export type VerificationTypeEnumV12 = typeof VerificationTypeEnumV12[keyof typeof VerificationTypeEnumV12];


/**
 * Client identification flag in basic register management (Správa základních registrů)
 * @export
 * @interface VerifiedInBRMV5x0
 */
export interface VerifiedInBRMV5x0 {
    /**
     * 
     * @type {boolean}
     * @memberof VerifiedInBRMV5x0
     */
    'valid': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VerifiedInBRMV5x0
     */
    'done'?: boolean;
}


/**
 * ActivationApi - axios parameter creator
 * @export
 */
export const ActivationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get information about blockage of new activations for the client.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewActivationsBlockageInfoV12: async (xCorrelationId: string, pidUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getNewActivationsBlockageInfoV12', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'pidUuid' is not null or undefined
            assertParamExists('getNewActivationsBlockageInfoV12', 'pidUuid', pidUuid)
            const localVarPath = `/pid-backofficegateway-pid-external/v12/pid/{pidUuid}/activations/new-activations-blockage-info`
                .replace(`{${"pidUuid"}}`, encodeURIComponent(String(pidUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActivationApi - functional programming interface
 * @export
 */
export const ActivationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActivationApiAxiosParamCreator(configuration)
    return {
        /**
         * Get information about blockage of new activations for the client.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNewActivationsBlockageInfoV12(xCorrelationId: string, pidUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewActivationsBlockageInfoV12>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNewActivationsBlockageInfoV12(xCorrelationId, pidUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ActivationApi - factory interface
 * @export
 */
export const ActivationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActivationApiFp(configuration)
    return {
        /**
         * Get information about blockage of new activations for the client.
         * @param {ActivationApiGetNewActivationsBlockageInfoV12Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewActivationsBlockageInfoV12(requestParameters: ActivationApiGetNewActivationsBlockageInfoV12Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<NewActivationsBlockageInfoV12> {
            return localVarFp.getNewActivationsBlockageInfoV12(requestParameters.xCorrelationId, requestParameters.pidUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getNewActivationsBlockageInfoV12 operation in ActivationApi.
 * @export
 * @type ActivationApiGetNewActivationsBlockageInfoV12Request
 */
export type ActivationApiGetNewActivationsBlockageInfoV12Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof ActivationApiGetNewActivationsBlockageInfoV12
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof ActivationApiGetNewActivationsBlockageInfoV12
     */
    readonly pidUuid: string
}

/**
 * ActivationApi - object-oriented interface
 * @export
 * @class ActivationApi
 * @extends {BaseAPI}
 */
export class ActivationApi extends BaseAPI {
    /**
     * Get information about blockage of new activations for the client.
     * @param {ActivationApiGetNewActivationsBlockageInfoV12Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivationApi
     */
    public getNewActivationsBlockageInfoV12(requestParameters: ActivationApiGetNewActivationsBlockageInfoV12Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return ActivationApiFp(this.configuration).getNewActivationsBlockageInfoV12(requestParameters.xCorrelationId, requestParameters.pidUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PidApi - axios parameter creator
 * @export
 */
export const PidApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creating a request for approval of a new consent by the client.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {ConsentAgreementV12} consentAgreementV12 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeConsentV12: async (xCorrelationId: string, pidUuid: string, consentAgreementV12: ConsentAgreementV12, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('changeConsentV12', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'pidUuid' is not null or undefined
            assertParamExists('changeConsentV12', 'pidUuid', pidUuid)
            // verify required parameter 'consentAgreementV12' is not null or undefined
            assertParamExists('changeConsentV12', 'consentAgreementV12', consentAgreementV12)
            const localVarPath = `/pid-backofficegateway-pid-external/v12/pid/{pidUuid}/consent-change`
                .replace(`{${"pidUuid"}}`, encodeURIComponent(String(pidUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(consentAgreementV12, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creating a request for approval of a new contact address by the client.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {AddressV12} addressV12 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeContactAddressV12: async (xCorrelationId: string, pidUuid: string, addressV12: AddressV12, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('changeContactAddressV12', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'pidUuid' is not null or undefined
            assertParamExists('changeContactAddressV12', 'pidUuid', pidUuid)
            // verify required parameter 'addressV12' is not null or undefined
            assertParamExists('changeContactAddressV12', 'addressV12', addressV12)
            const localVarPath = `/pid-backofficegateway-pid-external/v12/pid/{pidUuid}/contact-address-change`
                .replace(`{${"pidUuid"}}`, encodeURIComponent(String(pidUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addressV12, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Collect alerts associated with given client. Supported alerts:   * `CLIENT_DATA_EMAIL_MISSING`   * `CLIENT_DATA_PHONE_MISSING`   * `CLIENT_DATA_PERMANENT_ADDRESS_MISSING`   * `CLIENT_APPLICATIONS_BLOCKED`   * `CLIENT_NEW_ACTIVATIONS_BLOCKED`   * `CLIENT_ACTIVATIONS_WAITING_FOR_MANUAL_IDENTIFICATION`   * `CLIENT_BANK_IDENTITY_BLOCKED`   * `CLIENT_PID_BLOCKED` 
         * @summary Collect client alerts.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {CollectAlertsRequestV12} [collectAlertsRequestV12] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        collectAlertsV12: async (xCorrelationId: string, pidUuid: string, collectAlertsRequestV12?: CollectAlertsRequestV12, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('collectAlertsV12', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'pidUuid' is not null or undefined
            assertParamExists('collectAlertsV12', 'pidUuid', pidUuid)
            const localVarPath = `/pid-backofficegateway-pid-external/v12/pid/{pidUuid}/alerts`
                .replace(`{${"pidUuid"}}`, encodeURIComponent(String(pidUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(collectAlertsRequestV12, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find advisor of client by pidUuid.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findClientAdvisorV12: async (xCorrelationId: string, pidUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('findClientAdvisorV12', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'pidUuid' is not null or undefined
            assertParamExists('findClientAdvisorV12', 'pidUuid', pidUuid)
            const localVarPath = `/pid-backofficegateway-pid-external/v12/pid/{pidUuid}/advisor`
                .replace(`{${"pidUuid"}}`, encodeURIComponent(String(pidUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find client devices by pidUuid.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findClientDevicesV12: async (xCorrelationId: string, pidUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('findClientDevicesV12', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'pidUuid' is not null or undefined
            assertParamExists('findClientDevicesV12', 'pidUuid', pidUuid)
            const localVarPath = `/pid-backofficegateway-pid-external/v12/pid/{pidUuid}/devices`
                .replace(`{${"pidUuid"}}`, encodeURIComponent(String(pidUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Getting history of changes of client\'s additional info.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdditionalClientInfoHistoryV12: async (xCorrelationId: string, pidUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getAdditionalClientInfoHistoryV12', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'pidUuid' is not null or undefined
            assertParamExists('getAdditionalClientInfoHistoryV12', 'pidUuid', pidUuid)
            const localVarPath = `/pid-backofficegateway-pid-external/v12/history/pid/{pidUuid}/additionalClientInfo`
                .replace(`{${"pidUuid"}}`, encodeURIComponent(String(pidUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Getting history of changes of client\'s address.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressHistoryV12: async (xCorrelationId: string, pidUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getAddressHistoryV12', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'pidUuid' is not null or undefined
            assertParamExists('getAddressHistoryV12', 'pidUuid', pidUuid)
            const localVarPath = `/pid-backofficegateway-pid-external/v12/history/pid/{pidUuid}/address`
                .replace(`{${"pidUuid"}}`, encodeURIComponent(String(pidUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Getting history of changes of client\'s info.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientInfoHistoryV12: async (xCorrelationId: string, pidUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getClientInfoHistoryV12', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'pidUuid' is not null or undefined
            assertParamExists('getClientInfoHistoryV12', 'pidUuid', pidUuid)
            const localVarPath = `/pid-backofficegateway-pid-external/v12/history/pid/{pidUuid}/clientInfo`
                .replace(`{${"pidUuid"}}`, encodeURIComponent(String(pidUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Getting history of changes of client\'s consent agreements.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsentAgreementHistoryV12: async (xCorrelationId: string, pidUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getConsentAgreementHistoryV12', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'pidUuid' is not null or undefined
            assertParamExists('getConsentAgreementHistoryV12', 'pidUuid', pidUuid)
            const localVarPath = `/pid-backofficegateway-pid-external/v12/history/pid/{pidUuid}/consentAgreements`
                .replace(`{${"pidUuid"}}`, encodeURIComponent(String(pidUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Getting history of changes of client\'s email.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailHistoryV12: async (xCorrelationId: string, pidUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getEmailHistoryV12', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'pidUuid' is not null or undefined
            assertParamExists('getEmailHistoryV12', 'pidUuid', pidUuid)
            const localVarPath = `/pid-backofficegateway-pid-external/v12/history/pid/{pidUuid}/email`
                .replace(`{${"pidUuid"}}`, encodeURIComponent(String(pidUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtaining the flag whether the PID is an employee of the partners group.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeV12: async (xCorrelationId: string, pidUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getEmployeeV12', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'pidUuid' is not null or undefined
            assertParamExists('getEmployeeV12', 'pidUuid', pidUuid)
            const localVarPath = `/pid-backofficegateway-pid-external/v12/pid/{pidUuid}/employee`
                .replace(`{${"pidUuid"}}`, encodeURIComponent(String(pidUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Getting history of changes of client\'s id card.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdCardHistoryV12: async (xCorrelationId: string, pidUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getIdCardHistoryV12', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'pidUuid' is not null or undefined
            assertParamExists('getIdCardHistoryV12', 'pidUuid', pidUuid)
            const localVarPath = `/pid-backofficegateway-pid-external/v12/history/pid/{pidUuid}/idCard`
                .replace(`{${"pidUuid"}}`, encodeURIComponent(String(pidUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Getting history of changes of client\'s national number.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNationalNumberHistoryV12: async (xCorrelationId: string, pidUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getNationalNumberHistoryV12', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'pidUuid' is not null or undefined
            assertParamExists('getNationalNumberHistoryV12', 'pidUuid', pidUuid)
            const localVarPath = `/pid-backofficegateway-pid-external/v12/history/pid/{pidUuid}/nationalNumber`
                .replace(`{${"pidUuid"}}`, encodeURIComponent(String(pidUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Getting history of changes of client\'s phone.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhoneHistoryV12: async (xCorrelationId: string, pidUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getPhoneHistoryV12', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'pidUuid' is not null or undefined
            assertParamExists('getPhoneHistoryV12', 'pidUuid', pidUuid)
            const localVarPath = `/pid-backofficegateway-pid-external/v12/history/pid/{pidUuid}/phone`
                .replace(`{${"pidUuid"}}`, encodeURIComponent(String(pidUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get basic details of Pid by given pidUuid.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {boolean} verifiedOnly Returns only verified data (VERIFIED or PID_VERIFIED)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPidBasicDetailV12: async (xCorrelationId: string, pidUuid: string, verifiedOnly: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getPidBasicDetailV12', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'pidUuid' is not null or undefined
            assertParamExists('getPidBasicDetailV12', 'pidUuid', pidUuid)
            // verify required parameter 'verifiedOnly' is not null or undefined
            assertParamExists('getPidBasicDetailV12', 'verifiedOnly', verifiedOnly)
            const localVarPath = `/pid-backofficegateway-pid-external/v12/pid/{pidUuid}/basic-data`
                .replace(`{${"pidUuid"}}`, encodeURIComponent(String(pidUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (verifiedOnly !== undefined) {
                localVarQueryParameter['verifiedOnly'] = verifiedOnly;
            }

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get detail of Pid by given pidUuid.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {boolean} verifiedOnly Returns only verified data (VERIFIED or PID_VERIFIED)
         * @param {PidUuidRequestV12} [pidUuidRequestV12] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPidDetailWithReasonV12: async (xCorrelationId: string, pidUuid: string, verifiedOnly: boolean, pidUuidRequestV12?: PidUuidRequestV12, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getPidDetailWithReasonV12', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'pidUuid' is not null or undefined
            assertParamExists('getPidDetailWithReasonV12', 'pidUuid', pidUuid)
            // verify required parameter 'verifiedOnly' is not null or undefined
            assertParamExists('getPidDetailWithReasonV12', 'verifiedOnly', verifiedOnly)
            const localVarPath = `/pid-backofficegateway-pid-external/v12/pid/{pidUuid}`
                .replace(`{${"pidUuid"}}`, encodeURIComponent(String(pidUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (verifiedOnly !== undefined) {
                localVarQueryParameter['verifiedOnly'] = verifiedOnly;
            }

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pidUuidRequestV12, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint for extended search of client in backoffice.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {SearchClientsRequestV12} searchClientsRequestV12 Search filter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchClientsV12: async (xCorrelationId: string, searchClientsRequestV12: SearchClientsRequestV12, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('searchClientsV12', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'searchClientsRequestV12' is not null or undefined
            assertParamExists('searchClientsV12', 'searchClientsRequestV12', searchClientsRequestV12)
            const localVarPath = `/pid-backofficegateway-pid-external/v12/pid/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchClientsRequestV12, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint for simple searching of clients in backoffice.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {SimpleSearchClientsRequestV12} simpleSearchClientsRequestV12 client search filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simpleSearchClientsV12: async (xCorrelationId: string, simpleSearchClientsRequestV12: SimpleSearchClientsRequestV12, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('simpleSearchClientsV12', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'simpleSearchClientsRequestV12' is not null or undefined
            assertParamExists('simpleSearchClientsV12', 'simpleSearchClientsRequestV12', simpleSearchClientsRequestV12)
            const localVarPath = `/pid-backofficegateway-pid-external/v12/pid/simple-search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(simpleSearchClientsRequestV12, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verify identity of the client with given pidUuid.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyIdentityV12: async (xCorrelationId: string, pidUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('verifyIdentityV12', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'pidUuid' is not null or undefined
            assertParamExists('verifyIdentityV12', 'pidUuid', pidUuid)
            const localVarPath = `/pid-backofficegateway-pid-external/v12/pid/{pidUuid}/verify-identity`
                .replace(`{${"pidUuid"}}`, encodeURIComponent(String(pidUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PidApi - functional programming interface
 * @export
 */
export const PidApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PidApiAxiosParamCreator(configuration)
    return {
        /**
         * Creating a request for approval of a new consent by the client.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {ConsentAgreementV12} consentAgreementV12 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeConsentV12(xCorrelationId: string, pidUuid: string, consentAgreementV12: ConsentAgreementV12, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeConsentV12(xCorrelationId, pidUuid, consentAgreementV12, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creating a request for approval of a new contact address by the client.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {AddressV12} addressV12 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeContactAddressV12(xCorrelationId: string, pidUuid: string, addressV12: AddressV12, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeContactAddressV12(xCorrelationId, pidUuid, addressV12, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Collect alerts associated with given client. Supported alerts:   * `CLIENT_DATA_EMAIL_MISSING`   * `CLIENT_DATA_PHONE_MISSING`   * `CLIENT_DATA_PERMANENT_ADDRESS_MISSING`   * `CLIENT_APPLICATIONS_BLOCKED`   * `CLIENT_NEW_ACTIVATIONS_BLOCKED`   * `CLIENT_ACTIVATIONS_WAITING_FOR_MANUAL_IDENTIFICATION`   * `CLIENT_BANK_IDENTITY_BLOCKED`   * `CLIENT_PID_BLOCKED` 
         * @summary Collect client alerts.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {CollectAlertsRequestV12} [collectAlertsRequestV12] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async collectAlertsV12(xCorrelationId: string, pidUuid: string, collectAlertsRequestV12?: CollectAlertsRequestV12, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectAlertsResponseV12>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.collectAlertsV12(xCorrelationId, pidUuid, collectAlertsRequestV12, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Find advisor of client by pidUuid.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findClientAdvisorV12(xCorrelationId: string, pidUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindClientAdvisorResponseV12>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findClientAdvisorV12(xCorrelationId, pidUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Find client devices by pidUuid.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findClientDevicesV12(xCorrelationId: string, pidUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindClientDevicesResponseV12>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findClientDevicesV12(xCorrelationId, pidUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Getting history of changes of client\'s additional info.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdditionalClientInfoHistoryV12(xCorrelationId: string, pidUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdditionalClientInfoHistoryResponseV12>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdditionalClientInfoHistoryV12(xCorrelationId, pidUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Getting history of changes of client\'s address.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAddressHistoryV12(xCorrelationId: string, pidUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddressHistoryResponseV12>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAddressHistoryV12(xCorrelationId, pidUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Getting history of changes of client\'s info.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientInfoHistoryV12(xCorrelationId: string, pidUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientInfoHistoryResponseV12>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientInfoHistoryV12(xCorrelationId, pidUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Getting history of changes of client\'s consent agreements.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConsentAgreementHistoryV12(xCorrelationId: string, pidUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConsentAgreementHistoryResponseV12>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConsentAgreementHistoryV12(xCorrelationId, pidUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Getting history of changes of client\'s email.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmailHistoryV12(xCorrelationId: string, pidUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailHistoryResponseV12>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmailHistoryV12(xCorrelationId, pidUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtaining the flag whether the PID is an employee of the partners group.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeeV12(xCorrelationId: string, pidUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnersEmployeeWrapperV12>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployeeV12(xCorrelationId, pidUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Getting history of changes of client\'s id card.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIdCardHistoryV12(xCorrelationId: string, pidUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdCardHistoryResponseV12>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIdCardHistoryV12(xCorrelationId, pidUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Getting history of changes of client\'s national number.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNationalNumberHistoryV12(xCorrelationId: string, pidUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NationalNumberHistoryResponseV12>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNationalNumberHistoryV12(xCorrelationId, pidUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Getting history of changes of client\'s phone.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPhoneHistoryV12(xCorrelationId: string, pidUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PhoneHistoryResponseV12>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPhoneHistoryV12(xCorrelationId, pidUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get basic details of Pid by given pidUuid.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {boolean} verifiedOnly Returns only verified data (VERIFIED or PID_VERIFIED)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPidBasicDetailV12(xCorrelationId: string, pidUuid: string, verifiedOnly: boolean, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PidBasicDetailV12>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPidBasicDetailV12(xCorrelationId, pidUuid, verifiedOnly, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get detail of Pid by given pidUuid.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {boolean} verifiedOnly Returns only verified data (VERIFIED or PID_VERIFIED)
         * @param {PidUuidRequestV12} [pidUuidRequestV12] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPidDetailWithReasonV12(xCorrelationId: string, pidUuid: string, verifiedOnly: boolean, pidUuidRequestV12?: PidUuidRequestV12, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PidDetailV12>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPidDetailWithReasonV12(xCorrelationId, pidUuid, verifiedOnly, pidUuidRequestV12, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint for extended search of client in backoffice.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {SearchClientsRequestV12} searchClientsRequestV12 Search filter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchClientsV12(xCorrelationId: string, searchClientsRequestV12: SearchClientsRequestV12, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchClientsResponseV12>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchClientsV12(xCorrelationId, searchClientsRequestV12, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint for simple searching of clients in backoffice.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {SimpleSearchClientsRequestV12} simpleSearchClientsRequestV12 client search filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async simpleSearchClientsV12(xCorrelationId: string, simpleSearchClientsRequestV12: SimpleSearchClientsRequestV12, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchClientsResponseV12>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.simpleSearchClientsV12(xCorrelationId, simpleSearchClientsRequestV12, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Verify identity of the client with given pidUuid.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyIdentityV12(xCorrelationId: string, pidUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyIdentityV12(xCorrelationId, pidUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PidApi - factory interface
 * @export
 */
export const PidApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PidApiFp(configuration)
    return {
        /**
         * Creating a request for approval of a new consent by the client.
         * @param {PidApiChangeConsentV12Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeConsentV12(requestParameters: PidApiChangeConsentV12Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<string> {
            return localVarFp.changeConsentV12(requestParameters.xCorrelationId, requestParameters.pidUuid, requestParameters.consentAgreementV12, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Creating a request for approval of a new contact address by the client.
         * @param {PidApiChangeContactAddressV12Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeContactAddressV12(requestParameters: PidApiChangeContactAddressV12Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<string> {
            return localVarFp.changeContactAddressV12(requestParameters.xCorrelationId, requestParameters.pidUuid, requestParameters.addressV12, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Collect alerts associated with given client. Supported alerts:   * `CLIENT_DATA_EMAIL_MISSING`   * `CLIENT_DATA_PHONE_MISSING`   * `CLIENT_DATA_PERMANENT_ADDRESS_MISSING`   * `CLIENT_APPLICATIONS_BLOCKED`   * `CLIENT_NEW_ACTIVATIONS_BLOCKED`   * `CLIENT_ACTIVATIONS_WAITING_FOR_MANUAL_IDENTIFICATION`   * `CLIENT_BANK_IDENTITY_BLOCKED`   * `CLIENT_PID_BLOCKED` 
         * @summary Collect client alerts.
         * @param {PidApiCollectAlertsV12Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        collectAlertsV12(requestParameters: PidApiCollectAlertsV12Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<CollectAlertsResponseV12> {
            return localVarFp.collectAlertsV12(requestParameters.xCorrelationId, requestParameters.pidUuid, requestParameters.collectAlertsRequestV12, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Find advisor of client by pidUuid.
         * @param {PidApiFindClientAdvisorV12Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findClientAdvisorV12(requestParameters: PidApiFindClientAdvisorV12Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<FindClientAdvisorResponseV12> {
            return localVarFp.findClientAdvisorV12(requestParameters.xCorrelationId, requestParameters.pidUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Find client devices by pidUuid.
         * @param {PidApiFindClientDevicesV12Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findClientDevicesV12(requestParameters: PidApiFindClientDevicesV12Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<FindClientDevicesResponseV12> {
            return localVarFp.findClientDevicesV12(requestParameters.xCorrelationId, requestParameters.pidUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Getting history of changes of client\'s additional info.
         * @param {PidApiGetAdditionalClientInfoHistoryV12Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdditionalClientInfoHistoryV12(requestParameters: PidApiGetAdditionalClientInfoHistoryV12Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<AdditionalClientInfoHistoryResponseV12> {
            return localVarFp.getAdditionalClientInfoHistoryV12(requestParameters.xCorrelationId, requestParameters.pidUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Getting history of changes of client\'s address.
         * @param {PidApiGetAddressHistoryV12Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddressHistoryV12(requestParameters: PidApiGetAddressHistoryV12Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<AddressHistoryResponseV12> {
            return localVarFp.getAddressHistoryV12(requestParameters.xCorrelationId, requestParameters.pidUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Getting history of changes of client\'s info.
         * @param {PidApiGetClientInfoHistoryV12Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientInfoHistoryV12(requestParameters: PidApiGetClientInfoHistoryV12Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<ClientInfoHistoryResponseV12> {
            return localVarFp.getClientInfoHistoryV12(requestParameters.xCorrelationId, requestParameters.pidUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Getting history of changes of client\'s consent agreements.
         * @param {PidApiGetConsentAgreementHistoryV12Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsentAgreementHistoryV12(requestParameters: PidApiGetConsentAgreementHistoryV12Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<ConsentAgreementHistoryResponseV12> {
            return localVarFp.getConsentAgreementHistoryV12(requestParameters.xCorrelationId, requestParameters.pidUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Getting history of changes of client\'s email.
         * @param {PidApiGetEmailHistoryV12Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailHistoryV12(requestParameters: PidApiGetEmailHistoryV12Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<EmailHistoryResponseV12> {
            return localVarFp.getEmailHistoryV12(requestParameters.xCorrelationId, requestParameters.pidUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Obtaining the flag whether the PID is an employee of the partners group.
         * @param {PidApiGetEmployeeV12Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeV12(requestParameters: PidApiGetEmployeeV12Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<PartnersEmployeeWrapperV12> {
            return localVarFp.getEmployeeV12(requestParameters.xCorrelationId, requestParameters.pidUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Getting history of changes of client\'s id card.
         * @param {PidApiGetIdCardHistoryV12Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdCardHistoryV12(requestParameters: PidApiGetIdCardHistoryV12Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<IdCardHistoryResponseV12> {
            return localVarFp.getIdCardHistoryV12(requestParameters.xCorrelationId, requestParameters.pidUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Getting history of changes of client\'s national number.
         * @param {PidApiGetNationalNumberHistoryV12Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNationalNumberHistoryV12(requestParameters: PidApiGetNationalNumberHistoryV12Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<NationalNumberHistoryResponseV12> {
            return localVarFp.getNationalNumberHistoryV12(requestParameters.xCorrelationId, requestParameters.pidUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Getting history of changes of client\'s phone.
         * @param {PidApiGetPhoneHistoryV12Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhoneHistoryV12(requestParameters: PidApiGetPhoneHistoryV12Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<PhoneHistoryResponseV12> {
            return localVarFp.getPhoneHistoryV12(requestParameters.xCorrelationId, requestParameters.pidUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Get basic details of Pid by given pidUuid.
         * @param {PidApiGetPidBasicDetailV12Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPidBasicDetailV12(requestParameters: PidApiGetPidBasicDetailV12Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<PidBasicDetailV12> {
            return localVarFp.getPidBasicDetailV12(requestParameters.xCorrelationId, requestParameters.pidUuid, requestParameters.verifiedOnly, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Get detail of Pid by given pidUuid.
         * @param {PidApiGetPidDetailWithReasonV12Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPidDetailWithReasonV12(requestParameters: PidApiGetPidDetailWithReasonV12Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<PidDetailV12> {
            return localVarFp.getPidDetailWithReasonV12(requestParameters.xCorrelationId, requestParameters.pidUuid, requestParameters.verifiedOnly, requestParameters.pidUuidRequestV12, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint for extended search of client in backoffice.
         * @param {PidApiSearchClientsV12Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchClientsV12(requestParameters: PidApiSearchClientsV12Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<SearchClientsResponseV12> {
            return localVarFp.searchClientsV12(requestParameters.xCorrelationId, requestParameters.searchClientsRequestV12, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint for simple searching of clients in backoffice.
         * @param {PidApiSimpleSearchClientsV12Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simpleSearchClientsV12(requestParameters: PidApiSimpleSearchClientsV12Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<SearchClientsResponseV12> {
            return localVarFp.simpleSearchClientsV12(requestParameters.xCorrelationId, requestParameters.simpleSearchClientsRequestV12, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Verify identity of the client with given pidUuid.
         * @param {PidApiVerifyIdentityV12Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyIdentityV12(requestParameters: PidApiVerifyIdentityV12Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<string> {
            return localVarFp.verifyIdentityV12(requestParameters.xCorrelationId, requestParameters.pidUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for changeConsentV12 operation in PidApi.
 * @export
 * @type PidApiChangeConsentV12Request
 */
export type PidApiChangeConsentV12Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof PidApiChangeConsentV12
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof PidApiChangeConsentV12
     */
    readonly pidUuid: string

    /**
     * 
     * @type {ConsentAgreementV12}
     * @memberof PidApiChangeConsentV12
     */
    readonly consentAgreementV12: ConsentAgreementV12
}

/**
 * Request parameters for changeContactAddressV12 operation in PidApi.
 * @export
 * @type PidApiChangeContactAddressV12Request
 */
export type PidApiChangeContactAddressV12Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof PidApiChangeContactAddressV12
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof PidApiChangeContactAddressV12
     */
    readonly pidUuid: string

    /**
     * 
     * @type {AddressV12}
     * @memberof PidApiChangeContactAddressV12
     */
    readonly addressV12: AddressV12
}

/**
 * Request parameters for collectAlertsV12 operation in PidApi.
 * @export
 * @type PidApiCollectAlertsV12Request
 */
export type PidApiCollectAlertsV12Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof PidApiCollectAlertsV12
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof PidApiCollectAlertsV12
     */
    readonly pidUuid: string

    /**
     * 
     * @type {CollectAlertsRequestV12}
     * @memberof PidApiCollectAlertsV12
     */
    readonly collectAlertsRequestV12?: CollectAlertsRequestV12
}

/**
 * Request parameters for findClientAdvisorV12 operation in PidApi.
 * @export
 * @type PidApiFindClientAdvisorV12Request
 */
export type PidApiFindClientAdvisorV12Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof PidApiFindClientAdvisorV12
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof PidApiFindClientAdvisorV12
     */
    readonly pidUuid: string
}

/**
 * Request parameters for findClientDevicesV12 operation in PidApi.
 * @export
 * @type PidApiFindClientDevicesV12Request
 */
export type PidApiFindClientDevicesV12Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof PidApiFindClientDevicesV12
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof PidApiFindClientDevicesV12
     */
    readonly pidUuid: string
}

/**
 * Request parameters for getAdditionalClientInfoHistoryV12 operation in PidApi.
 * @export
 * @type PidApiGetAdditionalClientInfoHistoryV12Request
 */
export type PidApiGetAdditionalClientInfoHistoryV12Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof PidApiGetAdditionalClientInfoHistoryV12
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof PidApiGetAdditionalClientInfoHistoryV12
     */
    readonly pidUuid: string
}

/**
 * Request parameters for getAddressHistoryV12 operation in PidApi.
 * @export
 * @type PidApiGetAddressHistoryV12Request
 */
export type PidApiGetAddressHistoryV12Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof PidApiGetAddressHistoryV12
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof PidApiGetAddressHistoryV12
     */
    readonly pidUuid: string
}

/**
 * Request parameters for getClientInfoHistoryV12 operation in PidApi.
 * @export
 * @type PidApiGetClientInfoHistoryV12Request
 */
export type PidApiGetClientInfoHistoryV12Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof PidApiGetClientInfoHistoryV12
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof PidApiGetClientInfoHistoryV12
     */
    readonly pidUuid: string
}

/**
 * Request parameters for getConsentAgreementHistoryV12 operation in PidApi.
 * @export
 * @type PidApiGetConsentAgreementHistoryV12Request
 */
export type PidApiGetConsentAgreementHistoryV12Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof PidApiGetConsentAgreementHistoryV12
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof PidApiGetConsentAgreementHistoryV12
     */
    readonly pidUuid: string
}

/**
 * Request parameters for getEmailHistoryV12 operation in PidApi.
 * @export
 * @type PidApiGetEmailHistoryV12Request
 */
export type PidApiGetEmailHistoryV12Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof PidApiGetEmailHistoryV12
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof PidApiGetEmailHistoryV12
     */
    readonly pidUuid: string
}

/**
 * Request parameters for getEmployeeV12 operation in PidApi.
 * @export
 * @type PidApiGetEmployeeV12Request
 */
export type PidApiGetEmployeeV12Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof PidApiGetEmployeeV12
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof PidApiGetEmployeeV12
     */
    readonly pidUuid: string
}

/**
 * Request parameters for getIdCardHistoryV12 operation in PidApi.
 * @export
 * @type PidApiGetIdCardHistoryV12Request
 */
export type PidApiGetIdCardHistoryV12Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof PidApiGetIdCardHistoryV12
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof PidApiGetIdCardHistoryV12
     */
    readonly pidUuid: string
}

/**
 * Request parameters for getNationalNumberHistoryV12 operation in PidApi.
 * @export
 * @type PidApiGetNationalNumberHistoryV12Request
 */
export type PidApiGetNationalNumberHistoryV12Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof PidApiGetNationalNumberHistoryV12
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof PidApiGetNationalNumberHistoryV12
     */
    readonly pidUuid: string
}

/**
 * Request parameters for getPhoneHistoryV12 operation in PidApi.
 * @export
 * @type PidApiGetPhoneHistoryV12Request
 */
export type PidApiGetPhoneHistoryV12Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof PidApiGetPhoneHistoryV12
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof PidApiGetPhoneHistoryV12
     */
    readonly pidUuid: string
}

/**
 * Request parameters for getPidBasicDetailV12 operation in PidApi.
 * @export
 * @type PidApiGetPidBasicDetailV12Request
 */
export type PidApiGetPidBasicDetailV12Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof PidApiGetPidBasicDetailV12
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof PidApiGetPidBasicDetailV12
     */
    readonly pidUuid: string

    /**
     * Returns only verified data (VERIFIED or PID_VERIFIED)
     * @type {boolean}
     * @memberof PidApiGetPidBasicDetailV12
     */
    readonly verifiedOnly: boolean
}

/**
 * Request parameters for getPidDetailWithReasonV12 operation in PidApi.
 * @export
 * @type PidApiGetPidDetailWithReasonV12Request
 */
export type PidApiGetPidDetailWithReasonV12Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof PidApiGetPidDetailWithReasonV12
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof PidApiGetPidDetailWithReasonV12
     */
    readonly pidUuid: string

    /**
     * Returns only verified data (VERIFIED or PID_VERIFIED)
     * @type {boolean}
     * @memberof PidApiGetPidDetailWithReasonV12
     */
    readonly verifiedOnly: boolean

    /**
     * 
     * @type {PidUuidRequestV12}
     * @memberof PidApiGetPidDetailWithReasonV12
     */
    readonly pidUuidRequestV12?: PidUuidRequestV12
}

/**
 * Request parameters for searchClientsV12 operation in PidApi.
 * @export
 * @type PidApiSearchClientsV12Request
 */
export type PidApiSearchClientsV12Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof PidApiSearchClientsV12
     */
    readonly xCorrelationId: string

    /**
     * Search filter.
     * @type {SearchClientsRequestV12}
     * @memberof PidApiSearchClientsV12
     */
    readonly searchClientsRequestV12: SearchClientsRequestV12
}

/**
 * Request parameters for simpleSearchClientsV12 operation in PidApi.
 * @export
 * @type PidApiSimpleSearchClientsV12Request
 */
export type PidApiSimpleSearchClientsV12Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof PidApiSimpleSearchClientsV12
     */
    readonly xCorrelationId: string

    /**
     * client search filter
     * @type {SimpleSearchClientsRequestV12}
     * @memberof PidApiSimpleSearchClientsV12
     */
    readonly simpleSearchClientsRequestV12: SimpleSearchClientsRequestV12
}

/**
 * Request parameters for verifyIdentityV12 operation in PidApi.
 * @export
 * @type PidApiVerifyIdentityV12Request
 */
export type PidApiVerifyIdentityV12Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof PidApiVerifyIdentityV12
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof PidApiVerifyIdentityV12
     */
    readonly pidUuid: string
}

/**
 * PidApi - object-oriented interface
 * @export
 * @class PidApi
 * @extends {BaseAPI}
 */
export class PidApi extends BaseAPI {
    /**
     * Creating a request for approval of a new consent by the client.
     * @param {PidApiChangeConsentV12Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PidApi
     */
    public changeConsentV12(requestParameters: PidApiChangeConsentV12Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return PidApiFp(this.configuration).changeConsentV12(requestParameters.xCorrelationId, requestParameters.pidUuid, requestParameters.consentAgreementV12, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creating a request for approval of a new contact address by the client.
     * @param {PidApiChangeContactAddressV12Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PidApi
     */
    public changeContactAddressV12(requestParameters: PidApiChangeContactAddressV12Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return PidApiFp(this.configuration).changeContactAddressV12(requestParameters.xCorrelationId, requestParameters.pidUuid, requestParameters.addressV12, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Collect alerts associated with given client. Supported alerts:   * `CLIENT_DATA_EMAIL_MISSING`   * `CLIENT_DATA_PHONE_MISSING`   * `CLIENT_DATA_PERMANENT_ADDRESS_MISSING`   * `CLIENT_APPLICATIONS_BLOCKED`   * `CLIENT_NEW_ACTIVATIONS_BLOCKED`   * `CLIENT_ACTIVATIONS_WAITING_FOR_MANUAL_IDENTIFICATION`   * `CLIENT_BANK_IDENTITY_BLOCKED`   * `CLIENT_PID_BLOCKED` 
     * @summary Collect client alerts.
     * @param {PidApiCollectAlertsV12Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PidApi
     */
    public collectAlertsV12(requestParameters: PidApiCollectAlertsV12Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return PidApiFp(this.configuration).collectAlertsV12(requestParameters.xCorrelationId, requestParameters.pidUuid, requestParameters.collectAlertsRequestV12, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find advisor of client by pidUuid.
     * @param {PidApiFindClientAdvisorV12Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PidApi
     */
    public findClientAdvisorV12(requestParameters: PidApiFindClientAdvisorV12Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return PidApiFp(this.configuration).findClientAdvisorV12(requestParameters.xCorrelationId, requestParameters.pidUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find client devices by pidUuid.
     * @param {PidApiFindClientDevicesV12Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PidApi
     */
    public findClientDevicesV12(requestParameters: PidApiFindClientDevicesV12Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return PidApiFp(this.configuration).findClientDevicesV12(requestParameters.xCorrelationId, requestParameters.pidUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Getting history of changes of client\'s additional info.
     * @param {PidApiGetAdditionalClientInfoHistoryV12Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PidApi
     */
    public getAdditionalClientInfoHistoryV12(requestParameters: PidApiGetAdditionalClientInfoHistoryV12Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return PidApiFp(this.configuration).getAdditionalClientInfoHistoryV12(requestParameters.xCorrelationId, requestParameters.pidUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Getting history of changes of client\'s address.
     * @param {PidApiGetAddressHistoryV12Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PidApi
     */
    public getAddressHistoryV12(requestParameters: PidApiGetAddressHistoryV12Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return PidApiFp(this.configuration).getAddressHistoryV12(requestParameters.xCorrelationId, requestParameters.pidUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Getting history of changes of client\'s info.
     * @param {PidApiGetClientInfoHistoryV12Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PidApi
     */
    public getClientInfoHistoryV12(requestParameters: PidApiGetClientInfoHistoryV12Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return PidApiFp(this.configuration).getClientInfoHistoryV12(requestParameters.xCorrelationId, requestParameters.pidUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Getting history of changes of client\'s consent agreements.
     * @param {PidApiGetConsentAgreementHistoryV12Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PidApi
     */
    public getConsentAgreementHistoryV12(requestParameters: PidApiGetConsentAgreementHistoryV12Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return PidApiFp(this.configuration).getConsentAgreementHistoryV12(requestParameters.xCorrelationId, requestParameters.pidUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Getting history of changes of client\'s email.
     * @param {PidApiGetEmailHistoryV12Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PidApi
     */
    public getEmailHistoryV12(requestParameters: PidApiGetEmailHistoryV12Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return PidApiFp(this.configuration).getEmailHistoryV12(requestParameters.xCorrelationId, requestParameters.pidUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtaining the flag whether the PID is an employee of the partners group.
     * @param {PidApiGetEmployeeV12Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PidApi
     */
    public getEmployeeV12(requestParameters: PidApiGetEmployeeV12Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return PidApiFp(this.configuration).getEmployeeV12(requestParameters.xCorrelationId, requestParameters.pidUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Getting history of changes of client\'s id card.
     * @param {PidApiGetIdCardHistoryV12Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PidApi
     */
    public getIdCardHistoryV12(requestParameters: PidApiGetIdCardHistoryV12Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return PidApiFp(this.configuration).getIdCardHistoryV12(requestParameters.xCorrelationId, requestParameters.pidUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Getting history of changes of client\'s national number.
     * @param {PidApiGetNationalNumberHistoryV12Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PidApi
     */
    public getNationalNumberHistoryV12(requestParameters: PidApiGetNationalNumberHistoryV12Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return PidApiFp(this.configuration).getNationalNumberHistoryV12(requestParameters.xCorrelationId, requestParameters.pidUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Getting history of changes of client\'s phone.
     * @param {PidApiGetPhoneHistoryV12Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PidApi
     */
    public getPhoneHistoryV12(requestParameters: PidApiGetPhoneHistoryV12Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return PidApiFp(this.configuration).getPhoneHistoryV12(requestParameters.xCorrelationId, requestParameters.pidUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get basic details of Pid by given pidUuid.
     * @param {PidApiGetPidBasicDetailV12Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PidApi
     */
    public getPidBasicDetailV12(requestParameters: PidApiGetPidBasicDetailV12Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return PidApiFp(this.configuration).getPidBasicDetailV12(requestParameters.xCorrelationId, requestParameters.pidUuid, requestParameters.verifiedOnly, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get detail of Pid by given pidUuid.
     * @param {PidApiGetPidDetailWithReasonV12Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PidApi
     */
    public getPidDetailWithReasonV12(requestParameters: PidApiGetPidDetailWithReasonV12Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return PidApiFp(this.configuration).getPidDetailWithReasonV12(requestParameters.xCorrelationId, requestParameters.pidUuid, requestParameters.verifiedOnly, requestParameters.pidUuidRequestV12, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint for extended search of client in backoffice.
     * @param {PidApiSearchClientsV12Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PidApi
     */
    public searchClientsV12(requestParameters: PidApiSearchClientsV12Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return PidApiFp(this.configuration).searchClientsV12(requestParameters.xCorrelationId, requestParameters.searchClientsRequestV12, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint for simple searching of clients in backoffice.
     * @param {PidApiSimpleSearchClientsV12Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PidApi
     */
    public simpleSearchClientsV12(requestParameters: PidApiSimpleSearchClientsV12Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return PidApiFp(this.configuration).simpleSearchClientsV12(requestParameters.xCorrelationId, requestParameters.simpleSearchClientsRequestV12, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verify identity of the client with given pidUuid.
     * @param {PidApiVerifyIdentityV12Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PidApi
     */
    public verifyIdentityV12(requestParameters: PidApiVerifyIdentityV12Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return PidApiFp(this.configuration).verifyIdentityV12(requestParameters.xCorrelationId, requestParameters.pidUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Getting list of last viewed clients.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastViewedClientsV12: async (xCorrelationId: string, count?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getLastViewedClientsV12', 'xCorrelationId', xCorrelationId)
            const localVarPath = `/pid-backofficegateway-pid-external/v12/user/history/last-viewed-clients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * Getting list of last viewed clients.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLastViewedClientsV12(xCorrelationId: string, count?: number, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LastViewedClientsResponseV12>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLastViewedClientsV12(xCorrelationId, count, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * Getting list of last viewed clients.
         * @param {UserApiGetLastViewedClientsV12Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastViewedClientsV12(requestParameters: UserApiGetLastViewedClientsV12Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<LastViewedClientsResponseV12> {
            return localVarFp.getLastViewedClientsV12(requestParameters.xCorrelationId, requestParameters.count, options, endpointOptions).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getLastViewedClientsV12 operation in UserApi.
 * @export
 * @type UserApiGetLastViewedClientsV12Request
 */
export type UserApiGetLastViewedClientsV12Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof UserApiGetLastViewedClientsV12
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {number}
     * @memberof UserApiGetLastViewedClientsV12
     */
    readonly count?: number
}

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * Getting list of last viewed clients.
     * @param {UserApiGetLastViewedClientsV12Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getLastViewedClientsV12(requestParameters: UserApiGetLastViewedClientsV12Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return UserApiFp(this.configuration).getLastViewedClientsV12(requestParameters.xCorrelationId, requestParameters.count, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }
}


